const cssClasses = {
  imagepicker: {
    item: "sv_q_imgsel w-full inline-block !mr-0 text-center",
    image: "sv_image_image w-full mx-auto h-20 !object-cover checked:!bg-beige-100",
    root: "sv_imagesel grid grid-cols-2 tablet:grid-cols-2 gap-x-4 gap-y-4 justify-center",
    label:
      "sv_q_imgsel_label relative inline-block w-pxless h-pxless top-px text-center bg-beige-100 angle-corner-small checked:bg-terracotta-500",
    itemInline:
      "sv_q_imagepicker_inline angle-corner-small bg-beige-500 relative",
    itemText: "sv_q_imgsel_text text-[14px] font-medium inline-block py-3 px-2 checked:text-white",
    itemControl: "sv_q_imgsel_control_item hidden",
    itemDecorator: "",
    imageContainer:
      "sd-imagepicker__image-container border-b border-beige-500 checked:bg-terracotta-500",
    itemChecked: "sd-imagepicker__item--checked checked",
    checkedItemSvgIcon: "hidden",
    mainRoot: "sd-element sd-question sd-row__question bg-white max-w-[380px] chat-bubble py-4 px-4 mt-3",
  },
  radiogroup: {
    label:
      "sv_q_radiogroup_label justify-left relative inline-block w-pxless h-pxless top-px text-center bg-beige-100 cursor-pointer py-6 p-2.5 checked:bg-terracotta-500 angle-corner-small checked:text-white",
    itemControl: "sv_q_radiogroup_control_item hidden",
    item: "sv_q_radiogroup !w-full !p-0 angle-corner-small bg-beige-500 relative",
    root: "sv_qcbc text-center mt-2.5 grid grid-cols-2 justify-center gap-x-4 gap-y-2 tablet:gap-y-4",
    itemChecked: "checked bg-black",
  },
  text: {
    root: "justify-left relative inline-block w-pxless h-pxless top-px border border-red-600 cursor-pointer py-6 p-2.5",
  },
  question: {
    title: "sv_q_title text-[16px] font-main mb-2 capitalize font-bold",
    description: "text-[12px]",
    mainRoot: "sv_q sv_qstn py-2 px-2 mt-3 bg-white max-w-[380px] chat-bubble border border-[#EBEBEB] tablet:px-4 tablet:py-4",
    titleBar: "hidden",
  },
  html: {
    mainRoot: "sv_q sv_qstn",
  },
};

const modalQuestionContent =  {
  "question1": `
    <div>
      <div style="margin-bottom: 20px;">
        <strong>Thin</strong>
        <p>
          People with this body type have a slender frame & may find it hard
          to gain weight or muscle.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Medium</strong>
        <p>
          Your body may naturally retain some muscle and body fat, but you're
          not overweight.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Large</strong>
        <p>
          You have a broader frame & may find it easier to gain weight and
          muscle.
        </p>
      </div>
      <p style="color: #E78471;">
        Don't worry about minor fluctuations in size!
      </p>
    </div>
  `,
  "question4": `
    <div>
      <div style="margin-bottom: 20px;">
        <strong>Less</strong>
        <p>
          You Sweat Very Little, Even During Hot Or Physical Activity.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Normal</strong>
        <p>
         You Sweat A Moderate Amount During Warm Weather Or Physical Activity
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>More</strong>
        <p>
          You Tend To Sweat Heavily, Even With Minimal Physical Exertion.
        </p>
      </div>
      <p style="color: #9E6D44;">
        <strong>If Unsure,</strong> Think About How Much You Sweat Compared To Others In Similar Situations. This Can Help You Choose The Best Option!
      </p>
    </div>
  `,
  "question20": `
    <div>
      <div style="margin-bottom: 20px;">
        <strong>Irregular</strong>
        <p>
          You May Skip Meals Or Forget To Eat Because You Don’t Feel Consistently Hungry.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Normal</strong>
        <p>
         You Generally Feel Hungry At Regular Meal Times, Like Breakfast, Lunch, And Dinner
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Strong</strong>
        <p>
          Your Meals May Need To Be Larger Or More Frequent To Satisfy Your Hunger.
        </p>
      </div>
    </div>
  `,
  "question11": `
    <div>
      <div style="margin-bottom: 20px;">
        <strong>Fine</strong>
        <p>
          You Might Notice That Your Hair Tends To Get Flat And Lacks Body Or Bounce.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Medium</strong>
        <p>
         It Feels Full But Not Overly Heavy, With Decent Body And Movement.
         </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Thick</strong>
        <p>
          You Likely Have A Lot Of Hair, Which Gives It A Fuller, More Voluminous Appearance.
        </p>
      </div>
      <p style="color: #9E6D44;">
        <strong>If Unsure,</strong> Focus On The Overall Density And Weight Of Your Hair.
      </p>
    </div>
  `,
  "question12": `
    <div>
      <div style="margin-bottom: 20px;">
        <strong>Wavy</strong>
        <p>
          Your Hair Has A Natural Wave, Typically Forming Loose “S” Shapes.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Straight</strong>
        <p>
         Your Hair Falls Flat And Smooth From The Roots To The Ends, With Little To No Curl Or Wave.
         </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Curly</strong>
        <p>
          Your Hair Forms Defined Curls Or Spirals That Start At The Roots Or Mid-Length.
        </p>
      </div>
      <p style="color: #9E6D44;">
        <strong>If Unsure,</strong> Think About How Your Hair Behaves Naturally Without Styling.
       </p>
    </div>
  `,
  "question13a": `
    <div>
      <div style="margin-bottom: 20px;">
        <strong>Rough And Dry</strong>
        <p>
          It Often Feels Dry, Frizzy, Or Prone To Breakage, Especially At The Ends.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Silky And Smooth</strong>
        <p>
         It’s Usually Easy To Run Your Fingers Through, With Minimal Tangles Or Frizz.
         </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Full And Lustrous</strong>
        <p>
          It Has A Natural Shine And Volume, Looking Fuller And More Resilient.
        </p>
      </div>
      <p style="color: #9E6D44;">
        <strong>If Unsure,</strong> Focus On How Your Hair Feels To The Touch.
      </p>
    </div>
  `,
  "question13": `
    <div>
      <div style="margin-bottom: 20px;">
        <strong>Dry</strong>
        <p>
          Your Scalp Often Feels Tight, Itchy, Or Flaky.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Oily</strong>
        <p>
         Your Scalp Produces Excess Oil, Making Your Hair Look Greasy Or Shiny Soon After Washing.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Normal To Oily</strong>
        <p>
          Your Scalp Feels Balanced Most Of The Time But Can Become Slightly Oily, Particularly At The Roots.
        </p>
      </div>
      <p style="color: #9E6D44;">
        <strong>If Unsure,</strong> Think About How Your Scalp Feels After A Day Or Two Without Washing
      </p>
    </div>
  `,
  "questionhairstyling": `
    <div>
      <div style="margin-bottom: 20px;">
        <strong>Coloring </strong>
        <p>
          You’ve dyed or bleached your hair to change its color, whether partially (highlights, balayage) or completely.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Keratin </strong>
        <p>
         You've undergone a keratin treatment to reduce frizz, add shine, and make your hair straighter.
        </p>
      </div>
      <div style="margin-bottom: 20px;">
        <strong>Straightening or Smoothening</strong>
        <p>
          If your hair has been straightened, either chemically or with heat treatments, this option applies.
        </p>
      </div>
    </div>
  `,
};

const transitionPageContent = {
  "question-doshaprofileintro": `
   <div class='w-full relative min-h-[100vh] steps'style=background:#000000bf><header class='w-full glassy-header mb-3 z-50'><div class='flex items-center px-4 logo pt-4 text-center'><button class='h-5 header-back header-nav w-5'><img alt=prevBtn src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/guidon-vx-prev.svg?v=1737653149'></button> <img class='max-w-[180px] mx-auto'src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/vx-guidonb-white.svg?v=1737653023'alt='Vedix Logo'></div><div class='mb-3 z-50'><div class='mt-2 container formsteps max-w-4xl mx-auto pb-2 tablet:bg-transparent'><div class='flex items-center justify-center gap-x-2'><div class='transition-all group survey-section tablet:w-1/3 active w-6/9'data-section=diagnose data-section-start=diagnose-1/4><div class='text-white font-normal mb-1 text-body3 text-nowrap'>01<span class='transition-all absolute delay-300 group-[.active]:h-full group-[.active]:inline-block group-[.active]:opacity-100 group-[.active]:static group-[.active]:visible hidden invisible opacity-0 sectionTitleInfo tablet:opacity-100 tablet:static tablet:visible z-[-1]'> - Diagnosis</span></div><div class='w-full border border-solid border-terracotta-500 h-1.5 overflow-hidden'><div class='transition-all bg-terracotta-500 h-1.5 filler w-[25%]'></div></div></div><div class='transition-all group survey-section tablet:w-1/3 w-1/9'data-section=conclusionMessage data-section-start=conclusionMessage-1/3><div class='text-white font-normal mb-1 text-body3 text-nowrap'>02<span class='transition-all absolute delay-300 group-[.active]:h-full group-[.active]:inline-block group-[.active]:opacity-100 group-[.active]:static group-[.active]:visible hidden invisible opacity-0 sectionTitleInfo tablet:opacity-100 tablet:static tablet:visible z-[-1]'> - Result</span></div><div class='w-full border border-solid border-terracotta-500 h-1.5 overflow-hidden'><div class='transition-all bg-terracotta-500 h-1.5 group-[.completed]:w-full w-0'></div></div></div><div class='transition-all group survey-section tablet:w-1/3 w-1/9'data-section=result data-section-start=result-1/2><div class='text-white font-normal mb-1 text-body3 text-nowrap'>03<span class='transition-all absolute delay-300 group-[.active]:h-full group-[.active]:inline-block group-[.active]:opacity-100 group-[.active]:static group-[.active]:visible hidden invisible opacity-0 sectionTitleInfo tablet:opacity-100 tablet:static tablet:visible z-[-1]'> - HairCare Plan</span></div><div class='w-full border border-solid border-terracotta-500 h-1.5 overflow-hidden'><div class='transition-all bg-terracotta-500 h-1.5 group-[.completed]:w-full w-0'></div></div></div></div></div></div></header><div class='flex items-center justify-center flex-col px-3 w-full intersialPagewrapper overlay'><div class='flex justify-center relative intersial-wrapper min-h-[440px] w-full'><div class='flex items-center justify-center flex-col px-3 w-full absolute bg-white bottom-0 max-w-[340px] mx-auto pb-2 progress-header pt-4 rounded-lg shadow-lg'><div class='flex items-center justify-center mb-4 checkmark-container'><img class=w-10 src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/check_circle.png?v=1734087012'alt=Completed></div><h2 class='font-bold text-center text-xl'>Thanks For Telling Us About You!</h2><div class='flex justify-center mt-4 progress-indicator'><div class='w-full border bg-white border-[#EBEBEB] py-2 rounded-lg'><div class='flex items-center justify-center mb-4 gap-6 px-2'><div class='flex items-center flex-col step completed'><div class='flex items-center justify-center h-10 rounded-full w-10 text-white'><img class=w-6 src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/check_circle.png?v=1734087012'alt=Completed></div><p class='mt-2 font-medium text-[14px] text-green-500'>Your Details</div><div class='flex items-center flex-col step active'><div class='flex items-center justify-center h-10 rounded-full w-10 text-white'><img class=w-9 src='https://cdn.shopify.com/s/files/1/0563/5027/7747/files/current-section-glow.png?v=1734011134'alt=Current></div><p class='mt-2 font-medium text-[14px] text-[#DE5844]'>Dosha</div><div class='flex items-center flex-col step'><div class='flex items-center justify-center h-10 rounded-full w-10'><img class=pending-circle src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/pending-section-circle.png?v=1742560576'></div><p class='mt-2 font-medium text-[14px] text-gray-500'>Hair</div><div class='flex items-center flex-col step'><div class='flex items-center justify-center h-10 rounded-full w-10'><img class=pending-circle src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/pending-section-circle.png?v=1742560576'></div><p class='mt-2 font-medium text-[14px] text-gray-500'>Lifestyle</div></div><hr class='border-[#EBEBEB] border-t-1 my-4'><div class='px-2 next-section'><h3 class='text-[#9E6D44] text-xs uppercase'>Up Next...</h3><p class='font-bold text-[20px]'>Ayurvedic Dosha Profile<p class='text-[12px] text-gray-600'>Tell us a little about your body and lifestyle to help us assess your Tridoshic balance.</div></div></div><div class='w-full mt-4'id=intersial-fact><h4 class='text-[#9E6D44] mb-2 text-left text-sm'>Did You Know...</h4><div class='flex items-center justify-start space-x-2'><img class='w-9 h-12'src='https://cdn.shopify.com/s/files/1/0563/5027/7747/files/cosmpt-award.png?v=1734010149'alt=award><div><p class='text-xs text-[#131818]'>Vedix Won Best Product For Hair Volume<p class='font-bold text-base text-black'>Cosmopolitan Award</div></div></div></div></div><div class='flex justify-center relative mt-4'id=intersial-presc-img><img class=intersialDoc class='intersialDoc h-14 w-14'src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/zeel_chat_icon_9ba777ab-e106-4027-8c3b-84d5aa98a5d9.png?v=1732796045'alt=doct></div><div class='flex items-center justify-center max-w-md pb-[80px] relative'id=intersial-testi-desc><img class=w-14 src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/circle-celeb-mul.png?v=1734086550'alt=circle-review><p class='text-white text-base' style='line-height:1; font-size:12px;'>Celebs Like Kajal Agarwal And Neha Dhupia Use Our Products Regularly</div><div class='fixed bottom-0 left-0 px-3 right-0'><div class='flex items-center justify-center text-white bg-[#DE5844] cursor-pointer max-w-md mx-auto my-2.5 px-4 py-3'id=prog-next><span>CONTINUE</span> <span class='flex flex-row min-h-6 min-w-6 relative'><svg class='absolute size-6 transition-transform animate-bounceAlpha'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg><path d='M0 0h24v24H0z'fill=none></path><path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path></svg> <svg class='absolute size-6 transition-transform animate-bounceAlphaDelay left-2'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg><path d='M0 0h24v24H0z'fill=none></path><path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path></svg></span></div></div></div></div>
`,
  "question-ayurvedaprofileintro": `
<div class="w-full relative min-h-[100vh] steps"style=background:#000000bf><header class="w-full glassy-header mb-3 z-50"><div class="flex items-center px-4 logo pt-4 text-center"><button class="h-5 header-back header-nav w-5"><img alt=prevBtn src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/guidon-vx-prev.svg?v=1737653149"></button> <img alt="Vedix Logo"class="max-w-[180px] mx-auto"src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/vx-guidonb-white.svg?v=1737653023"></div><div class="mb-3 z-50"><div class="mt-2 container formsteps max-w-4xl mx-auto pb-2 tablet:bg-transparent"><div class="flex items-center justify-center gap-x-2"><div class="transition-all group survey-section tablet:w-1/3 active w-6/9"data-section=diagnose data-section-start=diagnose-1/4><div class="text-white font-normal mb-1 text-body3 text-nowrap">01<span class="transition-all absolute delay-300 group-[.active]:h-full group-[.active]:inline-block group-[.active]:opacity-100 group-[.active]:static group-[.active]:visible hidden invisible opacity-0 sectionTitleInfo tablet:opacity-100 tablet:static tablet:visible z-[-1]"> - Diagnosis</span></div><div class="w-full border border-solid border-terracotta-500 h-1.5 overflow-hidden"><div class="h-1.5 bg-terracotta-500 w-[50%] transition-all filler"></div></div></div><div class="transition-all group survey-section tablet:w-1/3 w-1/9"data-section=conclusionMessage data-section-start=conclusionMessage-1/3><div class="text-white font-normal mb-1 text-body3 text-nowrap">02<span class="transition-all absolute delay-300 group-[.active]:h-full group-[.active]:inline-block group-[.active]:opacity-100 group-[.active]:static group-[.active]:visible hidden invisible opacity-0 sectionTitleInfo tablet:opacity-100 tablet:static tablet:visible z-[-1]"> - Result</span></div><div class="w-full border border-solid border-terracotta-500 h-1.5 overflow-hidden"><div class="transition-all bg-terracotta-500 group-[.completed]:w-full h-1.5 w-0"></div></div></div><div class="transition-all group survey-section tablet:w-1/3 w-1/9"data-section=result data-section-start=result-1/2><div class="text-white font-normal mb-1 text-body3 text-nowrap">03<span class="transition-all absolute delay-300 group-[.active]:h-full group-[.active]:inline-block group-[.active]:opacity-100 group-[.active]:static group-[.active]:visible hidden invisible opacity-0 sectionTitleInfo tablet:opacity-100 tablet:static tablet:visible z-[-1]"> - HairCare Plan</span></div><div class="w-full border border-solid border-terracotta-500 h-1.5 overflow-hidden"><div class="transition-all bg-terracotta-500 group-[.completed]:w-full h-1.5 w-0"></div></div></div></div></div></div></header><div class="flex items-center justify-center w-full flex-col px-3 intersialPagewrapper overlay"><div class="flex justify-center w-full intersial-wrapper min-h-[440px] relative"><div class="flex items-center justify-center w-full flex-col px-3 absolute bg-white bottom-0 max-w-[340px] mx-auto progress-header py-4 rounded-lg shadow-lg"><div class="flex items-center justify-center mb-4 checkmark-container"><img alt=Completed class=w-10 src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/check_circle.png?v=1734087012"></div><h2 class="font-bold text-center text-xl">Ayurvedic Dosha Profile</h2><div class="flex justify-center mt-4 progress-indicator"><div class="w-full border bg-white border-[#EBEBEB] py-2 rounded-lg"><div class="flex items-center justify-center mb-4 gap-6 px-2"><div class="flex items-center flex-col step completed"><div class="flex items-center justify-center h-10 rounded-full w-10 text-white"><img alt=Completed class=w-6 src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/check_circle.png?v=1734087012"></div><p class="mt-2 font-medium text-[14px] text-green-500">Your Details</div><div class="flex items-center flex-col step completed"><div class="flex items-center justify-center h-10 rounded-full w-10 text-white"><img alt=Completed class=w-6 src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/check_circle.png?v=1734087012"></div><p class="mt-2 font-medium text-[14px] text-green-500">Dosha</div><div class="flex items-center flex-col step active"><div class="flex items-center justify-center h-10 rounded-full w-10 text-white"><img alt=Current class=w-9 src="https://cdn.shopify.com/s/files/1/0563/5027/7747/files/current-section-glow.png?v=1734011134"></div><p class="mt-2 font-medium text-[14px] text-[#DE5844]">Hair</div><div class="flex items-center flex-col step"><div class="flex items-center justify-center h-10 rounded-full w-10"><div class="w-6 border-2 border-[#BFBFBF] h-6 inner-circle rounded-full"></div></div><p class="mt-2 font-medium text-[14px] text-gray-500">Lifestyle</div></div><hr class="border-[#EBEBEB] border-t-1 my-4"><div class="px-2 next-section"><h3 class="mb-1 text-[#9E6D44] text-xs uppercase">Up Next...</h3><p class="font-bold text-[20px]">Hair Profile<p class="text-[12px] text-gray-600">Let’s Know Your Hair Better. This Helps Customize The Perfect Care For Your Hair.</div></div></div><div class="w-full mt-4" id="intersial-fact"><h4 class="text-[#9E6D44] mb-2 text-left text-sm">Did You Know...</h4><div class="flex items-center justify-start space-x-2"><img alt=award class="w-9 h-12"src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/transition-award2.png?v=1737695051"><div><p class="text-[#131818] text-xs">Vedix Won Best Brands 2019 Award<p class="font-bold text-base text-black">The Economic Times</div></div></div></div></div><div class="flex justify-center mt-4 relative" id="intersial-presc-img"><img alt=doct class=intersialDoc class="intersialDoc h-14 w-14"src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/zeel_chat_icon_9ba777ab-e106-4027-8c3b-84d5aa98a5d9.png?v=1732796045"></div><div class="flex items-center justify-center max-w-md pb-[80px] relative" id="intersial-testi-desc"><img alt=circle-review class=w-14 src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/circle-celeb-mul.png?v=1734086550"><p class="text-white text-base" style='line-height:1; font-size:12px;'>Celebs Like Kajal Agarwal And Neha Dhupia Use Our Products Regularly</div><div class='px-3 bottom-0 fixed left-0 right-0'><div class='flex bg-[#DE5844] cursor-pointer items-center justify-center max-w-md mx-auto my-2.5 px-4 py-3 text-white'id=prog-next><span>CONTINUE</span> <span class='flex flex-row min-h-6 min-w-6 relative'><svg class='absolute size-6 transition-transform animate-bounceAlpha'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg><path d='M0 0h24v24H0z'fill=none></path><path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path></svg> <svg class='absolute size-6 transition-transform animate-bounceAlphaDelay left-2'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg><path d='M0 0h24v24H0z'fill=none></path><path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path></svg></span></div></div></div></div>`,
  "question-lifestyleintro": `
<div class="w-full relative min-h-[100vh] steps"style=background:#000000bf><header class="w-full glassy-header mb-3 z-50"><div class="flex items-center px-4 logo pt-4 text-center"><button class="h-5 header-back header-nav w-5"><img alt=prevBtn src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/guidon-vx-prev.svg?v=1737653149"></button> <img alt="Vedix Logo"class="max-w-[180px] mx-auto"src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/vx-guidonb-white.svg?v=1737653023"></div><div class="mb-3 z-50"><div class="mt-2 container formsteps max-w-4xl mx-auto pb-2 tablet:bg-transparent"><div class="flex items-center justify-center gap-x-2"><div class="transition-all group survey-section tablet:w-1/3 active w-6/9"data-section=diagnose data-section-start=diagnose-1/4><div class="text-white font-normal mb-1 text-body3 text-nowrap">01<span class="transition-all absolute delay-300 group-[.active]:h-full group-[.active]:inline-block group-[.active]:opacity-100 group-[.active]:static group-[.active]:visible hidden invisible opacity-0 sectionTitleInfo tablet:opacity-100 tablet:static tablet:visible z-[-1]"> - Diagnosis</span></div><div class="w-full border border-solid border-terracotta-500 h-1.5 overflow-hidden"><div class="h-1.5 bg-terracotta-500 transition-all w-[75%] filler"></div></div></div><div class="transition-all group survey-section tablet:w-1/3 w-1/9"data-section=conclusionMessage data-section-start=conclusionMessage-1/3><div class="text-white font-normal mb-1 text-body3 text-nowrap">02<span class="transition-all absolute delay-300 group-[.active]:h-full group-[.active]:inline-block group-[.active]:opacity-100 group-[.active]:static group-[.active]:visible hidden invisible opacity-0 sectionTitleInfo tablet:opacity-100 tablet:static tablet:visible z-[-1]"> - Result</span></div><div class="w-full border border-solid border-terracotta-500 h-1.5 overflow-hidden"><div class="transition-all bg-terracotta-500 group-[.completed]:w-full h-1.5 w-0"></div></div></div><div class="transition-all group survey-section tablet:w-1/3 w-1/9"data-section=result data-section-start=result-1/2><div class="text-white font-normal mb-1 text-body3 text-nowrap">03<span class="transition-all absolute delay-300 group-[.active]:h-full group-[.active]:inline-block group-[.active]:opacity-100 group-[.active]:static group-[.active]:visible hidden invisible opacity-0 sectionTitleInfo tablet:opacity-100 tablet:static tablet:visible z-[-1]"> - HairCare Plan</span></div><div class="w-full border border-solid border-terracotta-500 h-1.5 overflow-hidden"><div class="transition-all bg-terracotta-500 group-[.completed]:w-full h-1.5 w-0"></div></div></div></div></div></div></header><div class="flex items-center justify-center w-full flex-col px-3 intersialPagewrapper overlay"><div class="flex justify-center w-full intersial-wrapper min-h-[440px] relative"><div class="flex items-center justify-center w-full flex-col px-3 absolute bg-white bottom-0 max-w-[340px] mx-auto progress-header py-4 rounded-lg shadow-lg"><div class="flex items-center justify-center mb-4 checkmark-container"><img alt=Completed class=w-10 src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/check_circle.png?v=1734087012"></div><h2 class="font-bold text-center text-xl">Hair Profile Completed</h2><div class="flex justify-center mt-4 progress-indicator"><div class="w-full border bg-white border-[#EBEBEB] py-2 rounded-lg"><div class="flex items-center justify-center mb-4 gap-6 px-2"><div class="flex items-center flex-col step completed"><div class="flex items-center justify-center text-white h-10 rounded-full w-10"><img alt=Completed class=w-6 src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/check_circle.png?v=1734087012"></div><p class="mt-2 font-medium text-[14px] text-green-500">Your Details</div><div class="flex items-center flex-col step completed"><div class="flex items-center justify-center text-white h-10 rounded-full w-10"><img alt=Completed class=w-6 src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/check_circle.png?v=1734087012"></div><p class="mt-2 font-medium text-[14px] text-green-500">Dosha</div><div class="flex items-center flex-col step completed"><div class="flex items-center justify-center text-white h-10 rounded-full w-10"><img alt=Completed class=w-6 src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/check_circle.png?v=1734087012"></div><p class="mt-2 font-medium text-[14px] text-green-500">Hair</div><div class="flex items-center flex-col step active"><div class="flex items-center justify-center text-white h-10 rounded-full w-10"><img alt=Current class=w-9 src="https://cdn.shopify.com/s/files/1/0563/5027/7747/files/current-section-glow.png?v=1734011134"></div><p class="mt-2 font-medium text-[14px] text-[#DE5844]">Lifestyle</div></div><hr class="border-[#EBEBEB] border-t-1 my-4"><div class="px-2 next-section"><h3 class="mb-1 text-[#9E6D44] text-xs uppercase">Up Next...</h3><p class="font-bold text-[20px]">Lifestyle Profile<p class="text-[12px] text-gray-600">Tell Us About Your Lifestyle. This Helps Customize The Perfect Regimen For Your Hair.</div></div></div><div class="w-full mt-4" id="intersial-fact"><h4 class="text-[#9E6D44] mb-2 text-left text-sm">Did You Know...</h4><div class="flex items-center justify-start space-x-2"><img alt=award class="w-9 h-12"src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/transition-award2.png?v=1737695051"><div><p class="text-[#131818] text-xs">Vedix Won Best Brands 2019 Award<p class="font-bold text-base text-black">The Economic Times</div></div></div></div></div><div class="flex justify-center mt-4 relative" id="intersial-presc-img"><img alt=doct class=intersialDoc class="intersialDoc h-14 w-14"src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/zeel_chat_icon_9ba777ab-e106-4027-8c3b-84d5aa98a5d9.png?v=1732796045"></div><div class="flex items-center justify-center max-w-md pb-[80px] relative" id="intersial-testi-desc"><img alt=circle-review class=w-14 src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/circle-celeb-mul.png?v=1734086550"><p class="text-white text-base" style='line-height:1; font-size:12px;'>Celebs Like Kajal Agarwal And Neha Dhupia Use Our Products Regularly</div><div class='px-3 bottom-0 fixed left-0 right-0'><div class='flex bg-[#DE5844] cursor-pointer items-center justify-center max-w-md mx-auto my-2.5 px-4 py-3 text-white'id=prog-next><span>CONTINUE</span> <span class='flex flex-row min-h-6 min-w-6 relative'><svg class='absolute size-6 transition-transform animate-bounceAlpha'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg><path d='M0 0h24v24H0z'fill=none></path><path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path></svg> <svg class='absolute size-6 transition-transform animate-bounceAlphaDelay left-2'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg><path d='M0 0h24v24H0z'fill=none></path><path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path></svg></span></div></div></div></div>
`
}

const footerPageContent = {
  "question1cc": `
  <div class="flex flex-col text-[#9E6D44] relative top-3 items-center text-[14px]">
        <img src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/Paraben_Free_Guiding.svg?v=1737986230" class="w-5 h-5" alt="paraben"/>
        <span>Paraben Free</span>
    </div>
  `,
  "question1b": `
  <div class="flex flex-col text-[#9E6D44] relative top-3 items-center text-[14px]">
        <img src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/natural-ingredients-guided.svg?v=1746520378" class="w-5 h-5" alt="natureal"/> 
        <span>100% Natural Ingredients</span>
    </div>
  `,
  "question1": `
  <div class="flex flex-col text-[#9E6D44] relative top-3 items-center text-[14px]">
        <img src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/No_Synthetic_Guided.svg?v=1737991154" alt="synthetic" class="w-5 h-5"/>
        <span>No Synthetics Used</span> 
    </div>
  `,
  "question4": `
  <div class="flex flex-col text-[#9E6D44] relative top-3 items-center text-[14px]">
        <img src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/Backed_by_ayurveda.svg?v=1737991274" alt="ayur" class="w-5 h-5"/>
        <span>Backed By Ayurveda</span> 
    </div>
  `,
  "question20": `
  <div class="flex flex-col text-[#9E6D44] relative top-3 items-center text-[14px]">
        <img src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/money-back-onb-gu.svg?v=1737783253" alt="ayur" class="w-5 h-5"/>
        <span>30 Day Money Back Guarantee</span> 
    </div>
  `,
  "question11": `
  <div id="testimonialCarousel" class="relative w-full max-w-[320px]  flex flex-col space-y-2 items-center"> 
  <!-- Slides Container -->
  <div id="slidesContainer" class="flex transition-transform duration-500 ease-in-out">
    <!-- Slides will be dynamically inserted here -->
  </div>
  <!-- Navigation Dots -->
  <div class="flex mt-2 justify-center space-x-2">
    <div class="dot w-1 h-1 bg-gray-300 rounded-full"></div>
    <div class="dot w-1 h-1 bg-gray-300 rounded-full"></div>
    <div class="dot w-1 h-1 bg-gray-300 rounded-full"></div>
     <div class="dot w-1 h-1 bg-gray-300 rounded-full"></div>
    <div class="dot w-1 h-1 bg-gray-300 rounded-full"></div>
    <div class="dot w-1 h-1 bg-gray-300 rounded-full"></div>
  </div>
  
  <img class="absolute quote-left top-0 left-0" src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/quote-left-footer.png?v=1738039635" alt="qutoe-left">
<img class="absolute quote-right bottom-0 right-0" src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/quote-right-footer.png?v=1738039994" alt="qutoe-right"> 
</div>  
`,
}

const issues = {
  1001: ['icon-analysis-oilyscalp', 'icon-analysis-slowgrowth', 'icon-analysis-hairloss', 'icon-analysis-greying'],
  1002: [
    'icon-analysis-oilyscalp',
    'icon-analysis-slowgrowth',
    'icon-analysis-splitends',
    'icon-analysis-hairloss',
  ],
  1003: ['icon-analysis-oilyscalp', 'icon-analysis-dandruff', 'icon-analysis-hairloss', 'icon-analysis-greying'],
  1004: ['icon-analysis-dryness', 'icon-analysis-splitends', 'icon-analysis-hairloss', 'icon-analysis-greying'],
  1005: ['icon-analysis-oilyscalp', 'icon-analysis-dandruff', 'icon-analysis-slowgrowth', 'icon-analysis-hairloss'],
  1006: ['icon-analysis-dryness', 'icon-analysis-dandruff', 'icon-analysis-splitends', 'icon-analysis-hairloss'],
};

let isProgrammaticUpdate = false;

function createAndShowModal(content, modalTitle) {
  // Check if modal already exists in the DOM
  let modal = document.getElementById("help-modal");
  if (!modal) {
    // Create modal dynamically
    modal = document.createElement("div");
    modal.id = "help-modal";
    modal.style.cssText = `
      display: none; 
      position: fixed; 
      top: 0; 
      left: 0; 
      width: 100%; 
      height: 100%; 
      background: rgba(0,0,0,0.5); 
      z-index: 9999;
      display: flex; 
      justify-content: center; 
      align-items: center;
    `;
    modal.innerHTML = `
      <div id="modal-content-wrapper" style="
        background: white; 
        padding: 20px; 
        width: 90%; 
        max-width: 400px; 
        max-height: 90%; 
        overflow-y: auto; 
        position: relative;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
      ">
        <button id="close-modal" style="
          position: absolute; 
          top: 10px; 
          right: 10px; 
          background: transparent; 
          border: none; 
          font-size: 20px; 
          font-weight: bold; 
          cursor: pointer; 
          color: #555;
        ">✕</button>
        <h2 id="modal-title" style="font-size: 18px; margin-bottom: 15px; color: #333;"></h2>
        <div id="modal-content" style="font-size: 14px; color: #555;"></div>
      </div>
      <style>
        @media (max-width: 480px) {
          #modal-content-wrapper {
            width: 90%; 
            max-width: none; 
            padding: 15px;
          }
        }
      </style>
    `;
    document.body.appendChild(modal);

    // Close modal handler
    document.getElementById("close-modal").onclick = () => {
      modal.style.display = "none";
    };

    // Close modal on outside click
    modal.onclick = (e) => {
      if (e.target === modal) {
        modal.style.display = "none";
      }
    };
  }

  // Update the modal content and title
  const modalTitleElement = document.getElementById("modal-title");
  const modalContentElement = document.getElementById("modal-content");

  if (modalTitleElement && modalContentElement) {
    modalTitleElement.textContent = modalTitle; // Update modal title
    modalContentElement.innerHTML = content; // Update modal content
  } else {
    console.error("Modal elements not found in the DOM.");
  }

  // Display the modal
  modal.style.display = "flex";
}
let isIntroProfilePageVis = false;
function initImagePicker(survey, options) {
  if (options.question.getType() === "imagepicker" || options.question.getType() === "radiogroup") {
    const rowEls = options.htmlElement.querySelectorAll(".sv_q_imgsel_image");
    for (let i = 0; i < rowEls.length; i++) {
      const span = document.createElement("span");
      span.innerHTML = rowEls[i].outerHTML;
      rowEls[i].parentNode.insertBefore(span, rowEls[i]);
      rowEls[i].remove();
    }
  }
  document.querySelectorAll('.sv_image_image')?.forEach(vpqImg => {
    vpqImg.style.objectFit = 'cover';
  });
}
let isMaleUser = null;

function updateHistory(sender, options) {
  saveSurveyData(survey);
  console.log('Update history');
    const questions = survey.currentPage.questions;
    const directResponsePage = [0, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20];
    const singleResponsePage = [0];
    let userResponseText = null;

    // Iterate over questions
    for (let i = 0; i < questions.length; i++) {
      if (i === questions.length - 1) {
        let elemId = '#' + questions[i].id;
        // Determine if the current page requires direct response handling
        if (directResponsePage.includes(survey.currentPageNo)) {
          let currentQuestion = sender.currentPage.questions[0];

          // Handle single response logic
          if (singleResponsePage.includes(survey.currentPageNo)) {
            currentQuestion = sender.currentPage.questions[1];
          }

          // Retrieve user-selected value
          const userSelectedValue = Object.values(sender.currentPage.getValue())[0];

          // Safely find the text for the selected choice
          userResponseText = currentQuestion.choices?.find(
              (choice) => choice.value === userSelectedValue
          )?.text || "No response provided"; // Fallback to avoid null errors
        }
        // Close the options once answered
        if(!!document.querySelector(`${elemId} fieldset`)){
          document.querySelector(`${elemId} fieldset`).classList.remove('animate-collapse');
          document.querySelector(`${elemId} .sd-question__content`).classList.remove('animate-collapse');
        }
        if (!!document.querySelector(elemId)) {
          document.querySelector(`${elemId} fieldset`).classList.add('animate-collapse');
          document.querySelector(`${elemId} .sv_q_title`).classList.add('animate-title');
        }
        const userResponse = Object.values(sender.currentPage.getValue())[0] || "No response";

        setTimeout(() => {
          // Close the options once answered
          if (!!document.querySelector(`${elemId} .sd-question__content`)) document.querySelector(`${elemId} .sd-question__content`).classList.add('animate-collapse');
          // Get the user response or fallback to prevent errors
          // Determine gender for image URL
          if (!isMaleUser || options.question.name === 'question1c') {
            isMaleUser = userResponse === 'Male';
          }
          const imageUrl = isMaleUser ?
              'https://cdn.shopify.com/s/files/1/0630/8528/1507/files/male-resp.jpg?v=1733740951' :
              'https://cdn.shopify.com/s/files/1/0630/8528/1507/files/female-resp.jpg?v=1733740951';

          // Remove any previously response exist
          document.querySelector(`${elemId}-response-back`)?.remove();

          // Insert the response bubble into the DOM
          document.querySelector(elemId)?.insertAdjacentHTML('afterend', `
<div id="${elemId}-response" class="responseCont" style="display: flex; align-items: center; justify-content: flex-end; margin-top: 1rem;">
<div class="speech-bubble px-6 py-3 bg-white relative response-bubble capitalize rounded-[10px] border border-[#EBEBEB]">
${directResponsePage.includes(survey.currentPageNo) ? userResponseText : userResponse}
</div>
<img src='${imageUrl}' alt="User Icon" style="
width: 40px;
height: 40px;
border-radius: 50%;
margin-left: 10px;
box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
" />
</div>
`);
        }, 500);

        // Page collapse animation to slide up page
        setTimeout(() => {
          document.querySelector('.sd-body__page').classList.add('pageCollapse');
        }, 1000);

        // Automatically move to the next page after a delay
        isProgrammaticUpdate = true;
        setTimeout(() => {
          console.log('NEXT 1');
          survey.nextPage();
        }, 1200);
        setTimeout(() => {
          isProgrammaticUpdate = false;
        },1500)
      }
    }


    // Update browser history for the current page
    history.replaceState({
          page: sender.currentPageNo,
          answer: Object.values(sender.currentPage.getValue())[0],
        },
        "",
        `?page=${sender.currentPage.name}`
    );
}

function renderChatResponsesForPage(survey,options) {
  const questions = survey.currentPage.questions;
  const directResponsePage = [0, 3, 4, 5, 6, 7, 8, 9,10,12, 13, 14, 15, 16, 17, 18, 19, 20];
  const singleResponsePage = [0];
  questions.forEach((question) => {
    const elemId = question.id;

    const userResponse = survey.data[question.name]; // Retrieve stored response
    const userResponseText = question.choices?.find(
      (choice) => choice.value === Object.values(survey.currentPage.getValue())[0]
    )?.text || "No response provided";
    const isMaleUser = survey.data["question1c"] === "Male"; // Adjust gender logic if needed
    const imageUrl = isMaleUser
      ? "https://cdn.shopify.com/s/files/1/0630/8528/1507/files/male-resp.jpg?v=1733740951"
      : "https://cdn.shopify.com/s/files/1/0630/8528/1507/files/female-resp.jpg?v=1733740951";
    if (userResponse) {
      const existingBubble = document.querySelector(`#${elemId}-response-back`);
      if (existingBubble) {
        existingBubble.remove(); // Prevent duplicates
        if(!!document.querySelector(`#${elemId}`)) document.querySelector(`#${elemId} fieldset`).classList.remove('h-0','w-0');
      }
      document.querySelector(`#${elemId}`)?.insertAdjacentHTML("afterend", `
        <div id="${elemId}-response-back" class="responseCont" style="display: none; align-items: center; justify-content: flex-end; margin-top: 1rem;">
          <div class="speech-bubble px-6 py-3 bg-white relative response-bubble rounded-[10px] border border-[#EBEBEB]">
            ${directResponsePage.includes(survey.currentPageNo) ? userResponseText : userResponse} 
          </div>
          <img src="${imageUrl}" alt="User Icon" style="
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-left: 10px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          " />
        </div>  
      `);
    }
  });
  const question = options.question;
  if (question.name === "question1" || question.name === "question4"
    || question.name === "question20" || question.name === "question11"
    || question.name === "question12" || question.name === "question13a"
    || question.name === "question13" || question.name === "questionhairstyling"
  ) {
    const helpLink = document.createElement("a");
    helpLink.classList.add('needHelp')
    helpLink.textContent = "Need Help?";
    const modalTitle = question.title; // Use the current question's title
    const modalContent = modalQuestionContent[question.name]; // Dynamically fetch content for the current question

    helpLink.style.cssText = ` 
      display: block;
      margin-top: 10px;
      color: #DE5844;
      cursor: pointer;
      text-decoration: underline;
      width: fit-content;font-size:14px;
    `;

    helpLink.onclick = () => {
      if (modalContent) {
        createAndShowModal(modalContent, modalTitle);
      } else {
        console.error(`Content not found for question title: "${modalTitle}"`);
      }
    };

    const questionContainer = options.htmlElement;
    questionContainer.appendChild(helpLink);
  } else {
    const needHelpEle = document.querySelector('.needHelp');
    needHelpEle?.remove();
  }
  if(question.name === "question-hairLossDuration"){
    const durQueId = survey.currentPage.questions[0].id;
    document.querySelector(`#${durQueId} fieldset`).classList.add('!grid-cols-1','!gap-y-3');
  }

  if(options.question.name === 'question1c') {
    const nameQueId = survey.currentPage.questions[1].id;
    const nameQuestionEl = document.getElementById(nameQueId);

    if (nameQuestionEl && !document.getElementById(`${nameQueId}-subtext`)) {
      const subtextDiv = document.createElement('div');
      subtextDiv.id = `${nameQueId}-subtext`;
      subtextDiv.innerText = "FIRST THING FIRST";
      subtextDiv.style.cssText = "color: #9E6D44; font-size: 12px; margin-bottom: 4px;";

      const headerEl = nameQuestionEl.querySelector('.sd-question__header');
      if (headerEl) headerEl.prepend(subtextDiv);
    }
    console.log('first',nameQueId);
  }
  if(options.question.name === 'question1-name') {
    const nameQueId = survey.currentPage.questions[0].id;
    const nameQuestionEl = document.getElementById(nameQueId);

    if (nameQuestionEl && !document.getElementById(`${nameQueId}-subtext`)) {
      const subtextDiv = document.createElement('div');
      subtextDiv.id = `${nameQueId}-subtext`;
      subtextDiv.innerText = "ONE LAST THING";
      subtextDiv.style.cssText = "color: #9E6D44; font-size: 12px; margin-bottom: 4px;";

      const headerEl = nameQuestionEl.querySelector('.sd-question__header');
      if (headerEl) headerEl.prepend(subtextDiv);
    }
    console.log('dslkfs',nameQueId);
  }

  if (options.question.name === 'question1-name') {
    const nameQueId = survey.currentPage.questions[0].id;
    document.body.focus();
    document.body.click();
    document.querySelector(`#${nameQueId} h5`).classList.add('!mb-0');
    document.querySelector(`#${nameQueId} .sd-text__content`).classList.add('!mt-5');
    const input = options.htmlElement.querySelector(`#${nameQueId} input`);
    input.classList.add('!py-4');
    if (input) {
      const clearButton = document.createElement('img');
      clearButton.src = 'https://cdn.shopify.com/s/files/1/0656/8568/4476/files/x-circle.svg?v=1729141701';
      clearButton.alt = 'Clear';
      clearButton.className = 'absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer';
      clearButton.style.display = 'none';
      clearButton.id = 'clearTextBtn';

      document.body.click();
      // Add buttons to the parent element
      if (input.parentElement) {
        input.parentElement.classList.add('relative');
        input.parentElement.appendChild(clearButton);
        document.body.click();
      }

      let userInteracted = false;

      const toggleClearButtonVisibility = () => {
        if (input.value.trim() !== '') {
          input.removeAttribute('aria-invalid');
          clearButton.style.display = 'block';
        } else {
          clearButton.style.display = 'none';
        }
        document.body.click();
      };

      input.addEventListener('input', toggleClearButtonVisibility);

      clearButton.addEventListener('click', (event) => {
        event.preventDefault();
        input.value = '';
        input.dispatchEvent(new Event('input'));
        toggleClearButtonVisibility();
        document.body.click();
      });

      const continueBtn = document.createElement("button");
      continueBtn.id = "surveyComplete";
      continueBtn.innerHTML = `
      CONTINUE 
      <span class="arrowicons flex items-center justify-center">
        <span class="animate-bounceAlphaDelay h-2.5 w-2.5 bg-[url('https://cdn.shopify.com/s/files/1/0037/7690/5283/files/Path_688.svg?v=1585302755')] bg-no-repeat"></span>
        <span class="animate-bounceAlpha h-2.5 w-2.5 bg-[url('https://cdn.shopify.com/s/files/1/0037/7690/5283/files/Path_688.svg?v=1585302755')] bg-no-repeat"></span>
      </span>
    `;
      continueBtn.className = "btn-primary mx-auto my-2 w-full";
      document.querySelector(`#${nameQueId} .sd-text__content`).insertAdjacentElement('afterend', continueBtn);
      continueBtn.onclick = function () {
        history.pushState(
        { page: survey.currentPageNo },
        "",
        `?page=${survey.currentPage.name}`
      );
        if (typeof SkVxGtmSuite !== "undefined") {
          SkVxGtmSuite.utils.pushToDataLayer({
            event_id: uuidv4(),
            event: "vpqComplete",
            user_properties: {
              customer_gender: survey.getQuestionByName('question1c').value,
            },
          });
        }
        survey.completeLastPage();
      };
    }
    document.body.click();
    setTimeout(() => {
      document.body.click();
    },500)
  }
  // alert('before')
  if (options.question.name === 'question-doshaprofileintro' || options.question.name === 'question-ayurvedaprofileintro'
    || options.question.name === 'question-lifestyleintro') {
    document.body.click();
    // Hide MainContent
    // history.replaceState({ page: survey.currentPageNo }, "", location.pathname + `?page=${survey.currentPageNo}`);
    // history.pushState({ page: survey.currentPageNo }, "",  `?page=${survey.currentPage.name}`);
    // alert('after')
    const mainElement = document.querySelector('#MainContent');
    mainElement.classList.add('hidden');

    // Create a new div with the animated background
    const prevAnimatedDiv = document.querySelector('#animate-area');
    if(prevAnimatedDiv) {
      prevAnimatedDiv.remove();
    }
    const animatedDiv = document.createElement('div');
    animatedDiv.id = 'animate-area';
    animatedDiv.innerHTML = transitionPageContent[options.question.name];

    // Append the animatedDiv to the body
    function handleResize() {
      if (window.innerWidth <= 768) {
        document.querySelector('body').classList.add('vpqScrollLock');
      } else {
        document.querySelector('body').classList.remove('vpqScrollLock');
      }
    }

    handleResize();

    document.body.appendChild(animatedDiv);
    document.body.click();
    animatedDiv.click();

    document.querySelector('.glassy-header button').addEventListener('click', () => {
      mainElement.classList.remove('hidden');
      document.querySelector('#animate-area')?.classList.add('hidden');
      document.querySelector('body').classList.add('vpqScrollLock');
      survey.prevPage();
      document.body.querySelector('#animate-area');
      setTimeout(() => {
        animatedDiv.click();
        console.log('body clicked! intersial')
      },700);
    })
    // window.addEventListener('popstate', (event) => {
    //   event.preventDefault();
    //   const surveyPrevButton = document.querySelector('#surveyPrevButton');
    //   if (surveyPrevButton) {
    //     surveyPrevButton.click();
    //     console.log('#surveyPrevButton was triggered inside popstate logic.');
    //   } else {
    //     console.log('#surveyPrevButton not found.');
    //   }
    //   // mainElement.classList.remove('hidden');
    //   // document.querySelector('#animate-area')?.classList.add('hidden');
    //   // survey.prevPage();
    // });
    window.addEventListener('pageshow', (event) => {
      // If coming back from the bfcache, event.persisted will be true.
      document.body.focus();
      document.body.click();
    });

    document.querySelector('#prog-next')?.addEventListener('click', (e) => {
      isIntroProfilePageVis = true;
      mainElement.classList.remove('hidden');
      document.querySelector('#animate-area')?.classList.add('hidden');
      document.querySelector('body').classList.add('vpqScrollLock');
      console.log('NEXT 2');
      history.pushState({ page: survey.currentPageNo }, "",  `?page=${survey.currentPage.name}`);
      // alert('ok')
      survey.nextPage();
      setTimeout(() => {
        document.body.click();
        console.log('async clicked 300');
      },300)
    });

    setTimeout(function() {
      document.querySelector('.intersial-wrapper')?.classList.add('intersial-wrapper-bubble')
    }, 600);
  }
  document.addEventListener('DOMContentLoaded', event => {
    document.body.focus();
    document.body.click();
  })
  document.body.click();
  setTimeout(() => {
    document.body.click();
    console.log('All async clicked 500')
  },500)
}

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    console.log('🔄 Page restored from bfcache');
    document.body.focus();
    document.body.click();
  }
});


function renderFootersForPage(survey, options) {
  const footerLoaderDiv = document.querySelector('#footerLoader');
  const checkFooterTrustmakers = document.querySelector('#guaranteeCarouselMin');
  const checkFooterTestimonials = document.querySelector('#testimonialCarousel');
  if(survey.currentPageNo >= 0 && survey.currentPageNo <= 6 && !isVisible(checkFooterTrustmakers)) {
    footerLoaderDiv.innerHTML = `<div id="guaranteeCarouselMin" class="relative top-0 w-full max-w-[300px] flex flex-col items-center overflow-hidden h-[40px]">
  <!-- Slides Container -->
  <div id="guaranteeSlidesContainerMin" class="flex flex-col transition-transform duration-500 ease-in-out">
    <!-- Slides will be dynamically inserted here -->
  </div>
</div>`
    const guaranteeItems = [
      {
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/Paraben_Free_Guiding.svg?v=1737986230",
        text: "Paraben Free",
      },
      {
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/natural-ingredients-guided.svg?v=1746520378",
        text: "100% Natural Ingredients",
      },
      {
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/No_Synthetic_Guided.svg?v=1737991154",
        text: "No Synthetics Used",
      },
      {
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/Backed_by_ayurveda.svg?v=1737991274",
        text: "Backed By Ayurveda",
      },
      {
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/money-back-onb-gu.svg?v=1737783253",
        text: "30 Day Money Back Guarantee",
      },
    ];

    const guaranteeSlidesContainer = document.getElementById("guaranteeSlidesContainerMin");
    let currentIndexMin = 0;

// Function to create a slide
    function createGuaranteeSlideMin(item) {
      const slide = document.createElement("div");
      slide.className = "guarantee-slideMin";
      slide.innerHTML = `
    <img src="${item.image}" class="w-5 h-5" alt="${item.text}" />
    <span class="text-[#9E6D44] text-[14px]">${item.text}</span>
  `;
      return slide;
    }

// Function to initialize slides
    function initializeGuaranteeSlidesMin() {
      guaranteeItems.forEach((item) => {
        const slide = createGuaranteeSlideMin(item);
        guaranteeSlidesContainer.appendChild(slide);
      });
    }

// Function to update the carousel
    function updateGuaranteeCarouselMin() {
      guaranteeSlidesContainer.style.transition = "transform 0.5s ease-in-out";
      const slideHeight = 50; // Fixed height of each slide
      guaranteeSlidesContainer.style.transform = `translateY(-${currentIndexMin * slideHeight}px)`; // Scroll vertically to the current index

      if (currentIndexMin === guaranteeItems.length) {
        setTimeout(() => {
          guaranteeSlidesContainer.style.transition = "none"; // Disable transition
          guaranteeSlidesContainer.style.transform = "translateY(0px)";
          currentIndexMin = 0;
        }, 400);
      }
    }

// Automatically cycle through guarantee items
    setInterval(() => {
      currentIndexMin++; // Move to the next slide
      updateGuaranteeCarouselMin();
    }, 3000);

// Initial setup
    initializeGuaranteeSlidesMin();
    updateGuaranteeCarouselMin();
  }
  if(survey.currentPageNo >= 7 && !isVisible(checkFooterTestimonials)) {
    footerLoaderDiv.innerHTML = footerPageContent['question11'];
    const femaleTestimonials = [
      {
        name: "Vishakha Panchal",
        text: "Love how long and strong my hair is now.",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/visakah-panchal-guideing.png?v=1737992722",
      },
      {
        name: "Divya",
        text: "The best hair care products I’ve ever used!",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/divya-footer-rev2.png?v=1738047212",
      },
      {
        name: "Kirti Garg",
        text: "Zero hair fall and frizz. Unbelievable results.",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/kirti-gard-rev3.png?v=1738047781",
      },
      {
        name: "Gargee",
        text: "I have a flake-free scalp now.",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/gargee-rev4-footer.png?v=1738047992",
      },
      {
        name: "Deepti",
        text: "I am obsessed with these products!",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/deepthi-rev5-footer.png?v=1738047992",
      },
      {
        name: "Prerna",
        text: "I get so many compliments for my hair now.",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/priya-rev6-footr.png?v=1738047992",
      },
    ];
    let testimonials = femaleTestimonials;
    const maleTestimonials = [
      {
      name: "Ashok Raj",
      text: "Vedix in just 3 months hair fall and stress reduced.",
      image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/onboard-male1.png?v=1742888588",
      },
      {
        name: "Sahil Khan",
        text: "My hair feels so soft and healthy—I can't stop!",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/shil-onboad-male2.png?v=1742888721",
      },
      {
        name: "Pradeep Sinha",
        text: "Vedix regimen is all I use to keep my hair strong.",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/pradeep-sinha-mal3.png?v=1742899155",
      },
      {
        name: "Ashok Raj",
        text: "Vedix in just 3 months hair fall and stress reduced.",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/onboard-male1.png?v=1742888588",
      },
      {
        name: "Sahil Khan",
        text: "My hair feels so soft and healthy—I can't stop!",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/shil-onboad-male2.png?v=1742888721",
      },
      {
        name: "Pradeep Sinha",
        text: "Vedix regimen is all I use to keep my hair strong.",
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/pradeep-sinha-mal3.png?v=1742899155",
      },
    ]
    if(survey.data['question1c'] === 'Male') {
      testimonials = maleTestimonials;
      console.log(maleTestimonials);
    }
    const slidesContainer = document.getElementById("slidesContainer");
    const dots = document.querySelectorAll(".dot");

    let currentIndexFooter = 0;
    // Function to create a slide
    function createSlide(testimonial) {
      const slide = document.createElement("div");
      slide.className = "slide";
      slide.innerHTML = `
    <div class="rounded-full h-8 w-8 overflow-hidden "> 
      <img src="${testimonial.image}" alt="${testimonial.name}'s Picture" />
    </div>
    <h3 class="text-[14px] font-semibold">${testimonial.name}</h3>
    <p class="text-[12px] text-gray-700 opacity-70">${testimonial.text}</p>
  `;
      return slide;
    }

// Function to initialize slides
    function initializeSlides() {
      testimonials.forEach((testimonial) => {
        const slide = createSlide(testimonial);
        slidesContainer.appendChild(slide);
      });
    }

// Function to update the carousel
    function updateCarouselFooter() {
      const slideWidth = slidesContainer.clientWidth / testimonials.length;
      slidesContainer.style.transition = "transform 0.5s ease-in-out";
      slidesContainer.style.transform = `translateX(-${currentIndexFooter * 320}px)`;

      // Update active dot
      dots.forEach((dot, index) => {
        dot.style.backgroundColor = index === currentIndexFooter % testimonials.length ? "#DE5844" : "#EFC3B7";
      });

      // Reset to the first slide without animation when reaching the end
      if (currentIndexFooter === testimonials.length) {
        setTimeout(() => {
          slidesContainer.style.transition = "none"; // Disable transition for instant reset
          slidesContainer.style.transform = `translateX(0)`;
          currentIndexFooter = 0; // Reset the index
        }, 700); // Wait for the transition to complete
      }
    }

// Automatically cycle through testimonials
    setInterval(() => {
      currentIndexFooter = (currentIndexFooter + 1) % (testimonials.length + 1); // Include the cloned slide
      updateCarouselFooter();

    }, 3000);

// Initial setup
    initializeSlides();
    updateCarouselFooter();
  }
}

function updateNavigation(survey) {
  console.log('updated navigation');
  const currentPageName = survey.currentPage.name;
  if (survey.isFirstPage) document.querySelector(".header-back").classList.add("hidden");
  else document.querySelector(".header-back").classList.remove("hidden");

  if (!currentPageName) return;
  setTimeout(()=>{
    function fillerRemoveUp(filler,add){
      if (filler.classList.contains('w-0')) filler.classList.remove('w-0');
      if (filler.classList.contains('w-[25%]')) filler.classList.remove('w-[25%]');
      if (filler.classList.contains('w-[50%]')) filler.classList.remove('w-[50%]');
      if (filler.classList.contains('w-[75%]')) filler.classList.remove('w-[75%]');
      if (filler.classList.contains('w-full')) filler.classList.remove('w-full');
      filler.classList.add(add);
    }
    [...document.querySelectorAll("#MainContent .survey-section")].map((x,i) => {
      if(i == 0 && !!x.querySelector('.filler')) {
        let filler = x.querySelector('.filler');
        let pageNo = parseInt(survey.currentPageNo);
        if (pageNo < 2) {
          fillerRemoveUp(filler,'w-0')
        }
        else if (pageNo >= 2 && pageNo <= 5) {
          fillerRemoveUp(filler,'w-[25%]')
        }
        else if (pageNo >= 6 && pageNo <= 14) {
          fillerRemoveUp(filler,'w-[50%]')
        }
        else if (pageNo >= 15 && pageNo <= 23) {
          fillerRemoveUp(filler,'w-[75%]')
        }
        else if (pageNo == 24) {
          fillerRemoveUp(filler,'w-full');
        }
      }
      if((i == 1 || i == 2) && !!x.querySelector('.filler')) {
        fillerRemoveUp(filler,'w-0')
      }
    });
  },1000);

  document.title = survey.currentPage.questions[0].title;
// if the page is not answered yet or the answer has changed, add to history
  document.body.focus();
  document.body.click();
  if (
    Object.values(survey.currentPage.data).length === 0 || // page not answered yet
    (history.state &&
      history.state.answer !== Object.values(survey.currentPage.getValue())[0])  // answer changed
  ) {
    // alert('history')
    history.pushState(
      { page: survey.currentPageNo },
      "",
      `?page=${survey.currentPage.name}`
    );
  }
  document.body.focus();
  document.body.click();
}
function tieBreaker(params) {
  if (!params && params.length < 1) return;
  if (params[0] === null) return;
  const _data = this.survey.data;

  let prakruti;
  let v = 0,
    p = 0,
    k = 0;
  for (let key in _data) {
    if (_data.hasOwnProperty(key) && key !== "question14") {
      if (_data[key].toString().startsWith("Vata")) v++;
      if (_data[key].toString().startsWith("Pitta")) p++;
      if (_data[key].toString().startsWith("Kapha")) k++;
    }
  }
  if (v > p && v > k) {
    if (p === k || (p === 0 && k === 0)) {
      prakruti = "Vata";
    } else {
      prakruti = false;
    }
  } else if (p > v && p > k) {
    if (v === k || (v === 0 && k === 0)) {
      prakruti = "Pitta";
    } else {
      prakruti = false;
    }
  } else if (k > v && k > p) {
    if (v === p || (p === 0 && v === 0)) {
      prakruti = "Kapha";
    } else {
      prakruti = false;
    }
  } else {
    if (v === p) {
      prakruti = "Kapha";
    } else if (v === k) {
      prakruti = "Pitta";
    } else if (p === k) {
      prakruti = "Vata";
    } else {
      prakruti = false;
    }
  }
  return prakruti;
}
function surveyRendered() {
  if(getCookie("surveyData")) {
    survey.data = JSON.parse(decodeURIComponent(getCookie("surveyData")));
    survey.currentPage ='details-3/3';
  }
  window.surveyReady = true;
  document.dispatchEvent(new Event("surveyReady"));
  if (typeof SkVxGtmSuite !== "undefined") {
    SkVxGtmSuite.utils.pushToDataLayer({
      event: "dl_vpq_start",
    });
  }
}

function getPrakruti(vpq_result) {
  let v = 0,
    p = 0,
    k = 0,
    prakruti = null;
  for (const key in vpq_result) {
    if (vpq_result.hasOwnProperty(key)) {
      if (vpq_result[key].toString().indexOf("Vata") === 0) v++;
      if (vpq_result[key].toString().indexOf("Pitta") === 0) p++;
      if (vpq_result[key].toString().indexOf("Kapha") === 0) k++;
    }
  }

  if (v > p && v > k) {
    if (p > k) {
      prakruti = "Vata-Pitta";
    } else {
      prakruti = "Vata-Kapha";
    }
  } else if (p > v && p > k) {
    if (v > k) {
      prakruti = "Pitta-Vata";
    } else {
      prakruti = "Pitta-Kapha";
    }
  } else if (k > v && k > p) {
    if (v > p) {
      prakruti = "Kapha-Vata";
    } else {
      prakruti = "Kapha-Pitta";
    }
  } else if (v === p) {
    prakruti = "Vata-Pitta";
  } else if (p === k) {
    prakruti = "Pitta-Kapha";
  } else if (k === v) {
    prakruti = "Kapha-Vata";
  }
  return prakruti;
}
function setPrakrutiId(resp) {
  switch (resp.prakruti) {
    case "Kapha-Pitta":
      resp.prakrutiId = "1001";
      break;
    case "Kapha-Vata":
      resp.prakrutiId = "1002";
      break;
    case "Pitta-Kapha":
      resp.prakrutiId = "1003";
      break;
    case "Pitta-Vata":
      resp.prakrutiId = "1004";
      break;
    case "Vata-Kapha":
      resp.prakrutiId = "1005";
      break;
    case "Vata-Pitta":
      resp.prakrutiId = "1006";
      break;
    default:
      resp.prakrutiId = "1000";
  }
  return resp;
}
function setHairAndScalpType(vpq) {
  const hairType = vpq["question12"];
  const hairTexture = vpq["question13a"];
  const scalpTexture = vpq["question13"];
  if (hairTexture && hairType && scalpTexture) {
    switch (scalpTexture) {
      case "Kapha-Normal to oily":
        vpq.scalpTypeId = "5001";
        vpq.scalpType = "Normal to oily";
        break;
      case "Pitta-Oily":
        vpq.scalpTypeId = "5002";
        vpq.scalpType = "Oily";
        break;
      case "Vata-Dry":
        vpq.scalpTypeId = "5003";
        vpq.scalpType = "Dry";
        break;
      default:
        vpq.scalpTypeId = "5001";
        vpq.scalpType = "Normal to oily";
        break;
    }
    switch (hairType) {
      case "Kapha-Curly":
        vpq.hairTypeId = "5001";
        vpq.hairType = "Curly";
        break;
      case "Pitta-Straight":
        vpq.hairTypeId = "5002";
        vpq.hairType = "Straight";
        break;
      case "Vata-Wavy":
        vpq.hairTypeId = "5003";
        vpq.hairType = "Wavy";
        break;
      default:
        vpq.hairTypeId = "5001";
        vpq.hairType = "Curly";
        break;
    }
    switch (hairTexture) {
      case "Kapha-Full and lustrous":
        vpq.hairTextureId = "7001";
        vpq.hairTexture = "Normal to oily";
        break;
      case "Pitta-Silky and smooth":
        vpq.hairTextureId = "7002";
        vpq.hairTexture = "Oily";
        break;
      case "Vata-Rough and dry":
        vpq.hairTextureId = "7003";
        vpq.hairTexture = "Dry";
        break;
      default:
        vpq.hairTextureId = "7001";
        vpq.hairTexture = "Normal to oily";
        break;
    }
  }
  return vpq;
}
function setAlopeciaType(resp) {
  const dandruff = resp["question13b"];
  const baldPatch = resp["question-baldpatch"];
  const hairLoss = resp["question-hairLossAmount"];
  const hairLossDuration = resp["question-hairLossDuration"];
  let alopeciaTypeIdOptions;
  if(dandruff === "No" && baldPatch && hairLoss && hairLossDuration) {
    if(!baldPatch) return resp;
    alopeciaTypeIdOptions = {
      No: {
        No: "5001",
        Less: hairLossDuration === "<2" ? "5001" : "5003",
        More: hairLossDuration === "<2" ? "5001" : "5003"
      },
      More: {
        No: "5002",
        Less: "5003",
        More: "5003"
      }
    };
  } else {
    if(!baldPatch) return resp;
    alopeciaTypeIdOptions = {
      No: {
        No: "5004",
        Less: hairLossDuration === "<2" ? "5004" : "5006",
        More: hairLossDuration === "<2" ? "5004" : "5006"
      },
      More: {
        No: "5005",
        Less: "5006",
        More: "5006"
      }
    };
  }
  const alopeciaIdNames = {
    "5001": "Diffuse",
    "5002": "Androgenetic",
    "5003": "Overlap",
    "5004": "Dandruff Diffuse",
    "5005": "Dandruff Androgenetic",
    "5006": "Dandruff Overlap"
  }
  resp.alopeciaTypeId = alopeciaTypeIdOptions[baldPatch][hairLoss];
  resp.alopeciaType = alopeciaIdNames[resp.alopeciaTypeId];
  return resp;
}

function vpqComplete(result) {
  if(!!document.querySelector('#surveyPrevButton')) document.querySelector('#surveyPrevButton').classList.add('hidden');
  let currData = survey.data;
  currData.prakruti = getPrakruti(currData);
  currData = setHairAndScalpType(currData);
  currData = setPrakrutiId(currData);
  currData = setAlopeciaType(currData);
  const customerName = currData['question1-name'];
  const prodCategories = ['oil', 'shampoo', 'serum', 'conditioner', 'hairmask'];
  // outsideFunction(currData);
  // let tqContent = `<div class="sv_qstn"><div class='intro relative bg-white border chat-bubble border-[#EBEBEB] p-4 rounded-[6px] max-w-[380px]'><div class='absolute -left-[4px] hidden -translate-x-1/2 rotate-180 transform'> <div class='h-0 w-0 border-t-7 border-b-7 border-l-7 border-t-transparent border-b-transparent border-l-chtCol' style='position: relative;'> <div style='content: ''; position: absolute; top: -8px; left: -8px; width: 0; height: 0; border-top: 8px solid transparent; border-bottom: 8px solid transparent; border-left: 8px solid #FFFFFF;'></div> </div> </div><p class='font-bold text-[1.25rem]'>Fantastic 😄</p><p class='mb-4'>I’ve got everything I need! Based on what you’ve shared, I’m going to create your ayurvedic Profile and hair care plan tailored just for you. Hang tight while I work my magic!</p></div><div class='chat-bubble pb-36 hidden' id='analysisIntro'><div class='bg-white max-w-[610px] px-4 py-4 rounded-[6px]'><div class=py-4 id=profile><div class=px-4><h3 class='font-semibold text-[#131818] text-[24px]'>Your Ayurvedic Profile</h3><p class='mt-4 text-body1'>According to the answers from your quiz, you have <span class='font-bold imbalDosha-1'>Kapha</span> and <span class='font-bold imbalDosha-2'>Pitta</span> imbalance.<div class='flex flex-col gap-8 gap-x-20 my-6 tablet:flex-row'><div class='w-full max-w-xl'><div class='flex gap-3'id=dosha_grid><div class='relative vata vataSelector'><input class='peer sr-only'id=profile-vata name=profile-dosha type=radio value=vata data-gtm-form-interact-field-id=22 checked> <label class='flex border border-black/20 cursor-pointer h-12 p-1 peer-checked:after:absolute peer-checked:after:bg-terracotta-500 peer-checked:after:h-12 peer-checked:after:left-1/2 peer-checked:after:top-full peer-checked:after:w-0.5 peer-checked:ring-2 peer-checked:ring-terracotta-500 peer-checked:shadow-terracotta-500 place-items-center rounded-full w-12'for=profile-vata><img alt=vara src=https://cdn.shopify.com/s/files/1/0607/5098/7446/files/dosha-icon-vata.svg></label></div><div class='relative pitta pittaSelector'><input class='peer sr-only'id=profile-pitta name=profile-dosha type=radio value=pitta data-gtm-form-interact-field-id=20> <label class='flex border border-black/20 cursor-pointer h-12 p-1 peer-checked:after:absolute peer-checked:after:bg-terracotta-500 peer-checked:after:h-12 peer-checked:after:left-1/2 peer-checked:after:top-full peer-checked:after:w-0.5 peer-checked:ring-2 peer-checked:ring-terracotta-500 peer-checked:shadow-terracotta-500 place-items-center rounded-full w-12'for=profile-pitta><img alt=spitta src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/pitta-icon-guide.svg?v=1737723669'></label></div><div class='relative kapha kaphaSelector'><input class='peer sr-only'id=profile-kapha name=profile-dosha type=radio value=kapha data-gtm-form-interact-field-id=21> <label class='flex border border-black/20 cursor-pointer h-12 p-1 peer-checked:after:absolute peer-checked:after:bg-terracotta-500 peer-checked:after:h-12 peer-checked:after:left-1/2 peer-checked:after:top-full peer-checked:after:w-0.5 peer-checked:ring-2 peer-checked:ring-terracotta-500 peer-checked:shadow-terracotta-500 place-items-center rounded-full w-12'for=profile-kapha><img alt=kapha src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/kapha-onboard-guid.svg?v=1737723357'></label></div></div><div class='relative grid mt-8'><div class='col-start-1 row-start-1'><input class='peer sr-only'id=profile-vata-details name=profile-dosha-details type=radio value=vata checked><div class='bg-white block border border-2 border-terracotta duration-300 opacity-0 peer-checked:opacity-100 peer-checked:z-10 rounded-[8px] transition-all'><div class='flex items-center border-black border-b justify-between p-4 gap-3'><div class='flex flex-col'><h3 class='dynDoshaTitle text-h3'>Vata</h3><p class='flex composition-dosha-vata gap-2 text-body1'>Dosha Imbalance<div class='flex space-x-4'><span class='flex items-center gap-1'><span class='bg-grey-100 dosha_progress h-2 inline-block w-2'></span> <span class='bg-grey-100 dosha_progress h-2 inline-block w-2'></span> <span class='bg-grey-100 dosha_progress h-2 inline-block w-2'></span> <span class='bg-grey-100 dosha_progress h-2 inline-block w-2'></span> <span class='bg-grey-100 dosha_progress h-2 inline-block w-2'></span> </span><span class=composition-dosha-qty>24%</span></div></div><div class=w-24><img alt=vata src=https://cdn.shopify.com/s/files/1/0607/5098/7446/files/dosha-icon-vata.svg class=dynDoshaImage></div></div><p class='p-4 dynDoshaDesc'>Imbalance of Vata Dosha can lead to dry scalp, frizzy hair, dandruff, split-ends, hair thinning and more.</div></div></div></div></div></div></div><div class='flex flex-col desktop:flex-row desktop:items-start desktop:justify-between desktop:space-x-4 desktop:space-y-0 items-start px-4 space-y-4'><div><h3 class='mb-2 tablet:text-left text-base text-left'>Here’s How Elevated Doshas Are Affecting Your Hair Health</h3><div class='gap-2 grid grid-cols-4 max-w-xs'><div class='flex flex-col items-center hidden justify-center icon-analysis-oilyscalp'><span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-oilyscalp.svg?v=110247163275577291'class='rounded-full w-full'></span><p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Oily Scalp/Hair</div><div class='flex flex-col items-center hidden justify-center icon-analysis-dryness'><span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-dryness.svg?v=15675595713852022769'class='rounded-full w-full'></span><p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Dryness</div><div class='flex flex-col items-center hidden justify-center icon-analysis-slowgrowth'><span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-slowgrowth.svg?v=6347013884442754936'class='rounded-full w-full'></span><p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Slow Hair Growth</div><div class='flex flex-col items-center hidden justify-center icon-analysis-dandruff'><span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-dandruff.svg?v=1052128713290580803'class='rounded-full w-full'></span><p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Dandruff</div><div class='flex flex-col items-center hidden justify-center icon-analysis-splitends'><span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-splitends.svg?v=3599487504442013447'class='rounded-full w-full'></span><p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Split ends</div><div class='flex flex-col items-center hidden justify-center icon-analysis-hairloss'><span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-hairloss.svg?v=12910887037982373107'class='rounded-full w-full'></span><p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Hair fall</div><div class='flex flex-col items-center hidden justify-center icon-analysis-greying'><span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-greying.svg?v=5290820950952160979'class='rounded-full w-full'></span><p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Premature Greying</div></div></div></div></div><div class='w-full bg-[#FBF7F1] bottom-0 fixed left-0 py-2 px-4'><div class='flex flex-col items-center md:flex-row md:justify-between md:space-y-0 space-y-2'><button class='introCta flex items-center justify-center analysisNext bg-[#DE5844] border border-black font-semibold max-w-md px-4 py-2 text-white w-full'>CONTINUE <span class='flex flex-row min-h-6 min-w-6 relative'><svg class='transition-transform absolute size-6 animate-bounceAlpha'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg><path d='M0 0h24v24H0z'fill=none></path><path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path></svg> <svg class='transition-transform absolute size-6 animate-bounceAlphaDelay left-2'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg><path d='M0 0h24v24H0z'fill=none></path><path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path></svg></span></button><div class='flex flex-col items-center h-[24px] max-w-[300px] overflow-hidden relative w-full'id=guaranteeCarousel><div class='flex flex-col duration-500 ease-in-out transition-transform'id=guaranteeSlidesContainer></div></div></div></div></div><div class='pb-36 chat-bubble hidden' id=purchaseSection><div class='py-4 bg-white rounded-lg'><h2 class='font-bold text-[1.25rem] px-4'>Choose a Plan That’s Right for You</h2><div class='bg-white lg:flex px-4 rounded-lg'id=plans-section><div class='w-full mx-auto max-w-lg overflow-hidden relative'><div class='flex relative duration-500 ease-in-out gap-4 mt-3 transition-transform w-full'id=carousel><div class='absolute h-full lg:hidden w-[2%] left-0 prev-img'><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/sp3-2.png?v=1735210765'alt=prev class='w-full h-full object-cover object-right'></div><div class='flex justify-center mx-auto main-img relative w-[91%]'><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/sp3-4.png?v=1735210766'alt=main> <button class='absolute -translate-y-1/2 p-2 rounded-full text-white top-1/2 transform left-0'id=prev><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/carouesl-left-cir.png?v=1735211516'alt=pre></button> <button class='absolute -translate-y-1/2 p-2 rounded-full text-white top-1/2 transform right-0'id=next><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/carouesl-right-cir.png?v=1735211516'alt=nex></button></div><div class='absolute h-full lg:hidden w-[2%] next-img right-0'><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/sp3-5.png?v=1735210765'alt=next class='w-full h-full object-cover object-left'></div></div><div class='flex justify-center mb-4 mt-2 space-x-2'id=indicators></div></div><div id=planTextContent><div class='flex space-x-2 mb-6'><div class='flex justify-center px-2 border-2 border-[#6E6E6E4D] cursor-pointer flex-col items-start py-4 rounded-lg w-24 !bg-[#FFF8EB] !border-[#DE5844]'id=step3><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_check.svg?v=1714027670'alt=''class='h-4 mb-2 w-4 step3Img'> <label class='font-semibold text-gray-800'for=step3>3 Step</label> <span class='font-bold text-[1.25rem] text-[#DE5844]'>₹999</span></div><div class='flex justify-center px-2 border-2 border-[#6E6E6E4D] cursor-pointer flex-col items-start py-4 rounded-lg w-24'id=step4><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_uncheck.svg?v=1714027668'alt=''class='h-4 mb-2 w-4 step4Img'> <label class='font-semibold text-sm'for=step4>4 Step</label> <span class='font-bold text-[1.25rem] text-[#DE5844]'>₹1399</span></div><div class='flex justify-center px-2 border-2 border-[#6E6E6E4D] cursor-pointer flex-col items-start py-4 rounded-lg w-24'id=step5><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_uncheck.svg?v=1714027668'alt=''class='h-4 mb-2 w-4 step5Img'> <label class='font-semibold text-gray-800'for=step5>5 Step</label> <span class='font-bold text-[1.25rem] text-[#DE5844]'>₹1499</span></div></div><div class=text-left><h3 class='font-bold mb-3 text-gray-900 planTitle text-lg'>What included in 3 Step Hair Regime</h3><ul class=space-y-2><li class='flex items-center'><img src='https://cdn.shopify.com/s/files/1/0671/6686/3619/files/checkmark.svg?v=1701765920'class=mr-3> <span class='planContents'> Contains Oil, Shampoo & Serum </span><li class='flex items-center'><img src='https://cdn.shopify.com/s/files/1/0671/6686/3619/files/checkmark.svg?v=1701765920'class=mr-3> Helps control hair fall<li class='flex items-center'><img src='https://cdn.shopify.com/s/files/1/0671/6686/3619/files/checkmark.svg?v=1701765920'class=mr-3> Reduces hair damage and makes hair healthy</ul></div></div><div class='w-full bg-[#FBF7F1] bottom-0 fixed left-0 p-4'><div class='flex items-center flex-col md:flex-row md:justify-between md:space-y-0 space-y-2'><a class='flex items-center active justify-center bg-[#DE5844] border border-grey-200 cta_checkout h-[54px] max-w-md mx-auto w-full'data-plan=AP12 data-price-insider-new=1198 href=#select-plan id=cta_checkout><span class='flex items-center active justify-center bg-terracotta-500 font-semibold h-[49px] md:w-full px-2 sm:w-full text-white'>CONTINUE <span><span class='flex relative flex-row min-h-6 min-w-6'><svg class='absolute size-6 transition-transform animate-bounceAlpha'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg><path d='M0 0h24v24H0z'fill=none></path><path d='M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path></svg> <svg class='absolute size-6 transition-transform animate-bounceAlphaDelay left-2'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg><path d='M0 0h24v24H0z'fill=none></path><path d='M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path></svg></span></span></span></a><div class='flex flex-col items-center h-[24px] max-w-[300px] overflow-hidden relative w-full'id=guaranteeCarousel><div class='flex flex-col duration-500 ease-in-out transition-transform'id=guaranteeSlidesContainer></div></div></div></div></div></div></div></div></div>`;
  let tqContent = `<div class='sv_qstn'> <div id='analysisPreview'><div class='intro relative bg-white border chat-bubble border-[#EBEBEB] p-4 rounded-[6px] max-w-[380px]'> <div class='absolute -left-[4px] hidden -translate-x-1/2 rotate-180 transform'> <div class='h-0 w-0 border-t-7 border-b-7 border-l-7 border-t-transparent border-b-transparent border-l-chtCol' style='position: relative;'> <div style='content: ''; position: absolute; top: -8px; left: -8px; width: 0; height: 0; border-top: 8px solid transparent; border-bottom: 8px solid transparent; border-left: 8px solid #FFFFFF;'></div> </div> </div> <p class='font-bold text-[1.25rem]'>Fantastic 😄</p> <p class='mb-4'>I’ve got everything I need! Based on what you’ve shared, I’m going to create your ayurvedic Profile and hair care plan tailored just for you. Hang tight while I work my magic!</p></div><div class='chat-bubble pb-36 hidden' id='analysisIntro'> <div class='bg-white max-w-[610px] px-4 py-4 rounded-[6px]'> <div class=pb-4 id=profile> <div class=px-4> <h3 class='font-semibold text-[#131818] text-[24px]'><span class='custom-name-analysis capitalize'>Your</span> Ayurvedic Profile</h3> <p class='mt-4 text-body1'>According to the answers from your quiz, you have <span class='font-bold imbalDosha-1'>Kapha</span> and <span class='font-bold imbalDosha-2'>Pitta</span> imbalance. <div class='flex flex-col gap-8 gap-x-20 my-6 tablet:flex-row'> <div class='w-full max-w-xl'> <div class='flex gap-3'id=dosha_grid> <div class='relative vata vataSelector'><input class='peer sr-only'id=profile-vata name=profile-dosha type=radio value=vata data-gtm-form-interact-field-id=22 checked> <label class='flex border border-black/20 cursor-pointer h-12 p-1 peer-checked:after:absolute peer-checked:after:bg-terracotta-500 peer-checked:after:h-12 peer-checked:after:left-1/2 peer-checked:after:top-full peer-checked:after:w-0.5 peer-checked:ring-2 peer-checked:ring-terracotta-500 peer-checked:shadow-terracotta-500 place-items-center rounded-full w-12'for=profile-vata><img alt=vara src=https://cdn.shopify.com/s/files/1/0607/5098/7446/files/dosha-icon-vata.svg></label></div> <div class='relative pitta pittaSelector'><input class='peer sr-only'id=profile-pitta name=profile-dosha type=radio value=pitta data-gtm-form-interact-field-id=20> <label class='flex border border-black/20 cursor-pointer h-12 p-1 peer-checked:after:absolute peer-checked:after:bg-terracotta-500 peer-checked:after:h-12 peer-checked:after:left-1/2 peer-checked:after:top-full peer-checked:after:w-0.5 peer-checked:ring-2 peer-checked:ring-terracotta-500 peer-checked:shadow-terracotta-500 place-items-center rounded-full w-12'for=profile-pitta><img alt=spitta src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/pitta-icon-guide.svg?v=1737723669'></label></div> <div class='relative kapha kaphaSelector'><input class='peer sr-only'id=profile-kapha name=profile-dosha type=radio value=kapha data-gtm-form-interact-field-id=21> <label class='flex border border-black/20 cursor-pointer h-12 p-1 peer-checked:after:absolute peer-checked:after:bg-terracotta-500 peer-checked:after:h-12 peer-checked:after:left-1/2 peer-checked:after:top-full peer-checked:after:w-0.5 peer-checked:ring-2 peer-checked:ring-terracotta-500 peer-checked:shadow-terracotta-500 place-items-center rounded-full w-12'for=profile-kapha><img alt=kapha src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/kapha-onboard-guid.svg?v=1737723357'></label></div> </div> <div class='relative grid mt-8'> <div class='col-start-1 row-start-1' id='dosh-box-display'> <input class='peer sr-only'id=profile-vata-details name=profile-dosha-details type=radio value=vata checked> <div class='bg-white block border border-2 border-terracotta duration-300 opacity-0 peer-checked:opacity-100 peer-checked:z-10 rounded-[8px] transition-all'> <div class='flex items-center border-black border-b justify-between p-4 gap-3'> <div class='flex flex-col'> <h3 class='dynDoshaTitle text-h3'>Vata</h3> <p class='flex composition-dosha-vata gap-2 text-body1'>Dosha Imbalance <div class='flex space-x-4'><span class='flex items-center gap-1'><span class='bg-grey-100 dosha_progress h-2 inline-block w-2'></span> <span class='bg-grey-100 dosha_progress h-2 inline-block w-2'></span> <span class='bg-grey-100 dosha_progress h-2 inline-block w-2'></span> <span class='bg-grey-100 dosha_progress h-2 inline-block w-2'></span> <span class='bg-grey-100 dosha_progress h-2 inline-block w-2'></span> </span><span class=composition-dosha-qty>24%</span></div> </div> <div class=w-24><img alt=vata src=https://cdn.shopify.com/s/files/1/0607/5098/7446/files/dosha-icon-vata.svg class=dynDoshaImage></div> </div> <p class='p-4 dynDoshaDesc'>Imbalance of Vata Dosha can lead to dry scalp, frizzy hair, dandruff, split-ends, hair thinning and more. </div> </div> </div> </div> </div> </div> </div> <div class='flex flex-col desktop:flex-row desktop:items-start desktop:justify-between desktop:space-x-4 desktop:space-y-0 items-start px-4 space-y-4'> <div> <h3 class='mb-2 tablet:text-left text-base text-left'>Here’s How Elevated Doshas Are Affecting Your Hair Health</h3> <div class='gap-2 grid grid-cols-4 max-w-xs'> <div class='flex flex-col items-center hidden justify-center icon-analysis-oilyscalp'> <span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-oilyscalp.svg?v=110247163275577291'class='rounded-full w-full'></span> <p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Oily Scalp/Hair </div> <div class='flex flex-col items-center hidden justify-center icon-analysis-dryness'> <span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-dryness.svg?v=15675595713852022769'class='rounded-full w-full'></span> <p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Dryness </div> <div class='flex flex-col items-center hidden justify-center icon-analysis-slowgrowth'> <span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-slowgrowth.svg?v=6347013884442754936'class='rounded-full w-full'></span> <p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Slow Hair Growth </div> <div class='flex flex-col items-center hidden justify-center icon-analysis-dandruff'> <span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-dandruff.svg?v=1052128713290580803'class='rounded-full w-full'></span> <p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Dandruff </div> <div class='flex flex-col items-center hidden justify-center icon-analysis-splitends'> <span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-splitends.svg?v=3599487504442013447'class='rounded-full w-full'></span> <p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Split ends </div> <div class='flex flex-col items-center hidden justify-center icon-analysis-hairloss'> <span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-hairloss.svg?v=12910887037982373107'class='rounded-full w-full'></span> <p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Hair fall </div> <div class='flex flex-col items-center hidden justify-center icon-analysis-greying'> <span class='rounded-full flex-shrink-0 h-[40px] w-[40px]'><img alt=''src='//vedix.com/cdn/shop/files/icon-analysis-greying.svg?v=5290820950952160979'class='rounded-full w-full'></span> <p class='font-semibold overflow-hidden text-[12px] text-center text-ellipsis text-xs'>Premature Greying </div> </div> </div> </div> </div> <div class='w-full bg-[#FBF7F1] bottom-0 fixed left-0 py-2 px-4'> <div class='flex flex-col items-center md:flex-row md:justify-between md:space-y-0 space-y-2'> <button class='introCta flex items-center justify-center analysisNext bg-[#DE5844] border border-black font-semibold max-w-md px-4 py-4 text-white w-full h-[54px]'> CONTINUE <span class='flex flex-row min-h-6 min-w-6 relative'> <svg class='transition-transform absolute size-6 animate-bounceAlpha'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg> <path d='M0 0h24v24H0z'fill=none></path> <path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path> </svg> <svg class='transition-transform absolute size-6 animate-bounceAlphaDelay left-2'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg> <path d='M0 0h24v24H0z'fill=none></path> <path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path> </svg> </span> </button> <div class='flex flex-col items-center h-[24px] max-w-[300px] overflow-hidden relative w-full'id=guaranteeCarousel> <div class='flex flex-col duration-500 ease-in-out transition-transform'id=guaranteeSlidesContainer></div> </div> </div> </div></div></div><div class='pb-36 chat-bubble hidden' id=purchaseSection> <div class='py-4 bg-white rounded-lg'> <h2 class='font-bold text-[1.25rem] px-4'>Choose a Plan That’s Right for You</h2> <div class='bg-white lg:flex px-2 desktop:px-4 rounded-lg'id=plans-section> <div class='w-full mx-auto max-w-lg overflow-hidden relative'> <div class='flex relative duration-500 ease-in-out gap-4 mt-3 transition-transform w-full'id=carousel> <div class='absolute h-full hidden lg:hidden w-[2%] left-0 prev-img'><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/sp3-2.png?v=1735210765'alt=prev class='w-full h-full object-cover object-right'></div> <div class='flex justify-center mx-auto main-img relative w-full'><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/3-Step-Regimen.jpg?v=1735296934'alt=main> <button class='absolute -translate-y-1/2 p-2 hidden rounded-full text-white top-1/2 transform left-0'id=prev><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/carouesl-left-cir.png?v=1735211516'alt=pre></button> <button class='absolute -translate-y-1/2 p-2 rounded-full hidden text-white top-1/2 transform right-0'id=next><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/carouesl-right-cir.png?v=1735211516'alt=nex></button></div> <div class='absolute h-full hidden lg:hidden w-[2%] next-img right-0'><img src='https://cdn.shopify.com/s/files/1/0037/7690/5283/files/sp3-5.png?v=1735210765'alt=next class='w-full h-full object-cover object-left'></div> </div> <div class='flex justify-center mb-4 mt-2 hidden space-x-2'id=indicators></div> </div> <div id=planTextContent class="mt-4"> 
<div class="flex space-x-1 mb-6 justify-between desktop:justify-start">
 
  <div class="flex justify-center px-1 border-2 border-[#6E6E6E4D] cursor-pointer flex-col items-start py-4 w-24 !border-[#DE5844] desktop:px-2" id="step3">
    <img src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_check.svg?v=1714027670" alt="" class="h-4 mb-2 w-4 step3Img">
    <label class="font-semibold text-gray-800 text-[15px]" for="step3">3 Step</label>
    <div class="flex items-center space-x-1 text-[13px]">
      <span class="text-gray-500 opacity-30  line-through">₹1547</span>
      <span class="font-bold text-[#DE5844]" style="font-size: 14px;">₹999</span>
    </div>
    <div class="mt-1 rounded-[4px] px-2 py-[2px] text-[12px] text-white" style="background-color: #2DB433;">
      Save ₹548
    </div>
  </div>

  <div class="flex justify-center px-1 border-2 border-[#6E6E6E4D] cursor-pointer flex-col items-start py-4 w-24 desktop:px-2" id="step4">
    <img src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_uncheck.svg?v=1714027668" alt="" class="h-4 mb-2 w-4 step4Img">
    <label class="font-semibold text-gray-800 text-[15px]" for="step4">4 Step</label>
    <div class="flex items-center space-x-1 text-[13px]">
      <span class="text-gray-500 opacity-30 line-through">₹2046</span>
      <span class="font-bold text-[#DE5844]" style="font-size: 14px;">₹1399</span>
    </div>
    <div class="mt-1 rounded-[4px] px-2 py-[2px] text-[12px] text-white" style="background-color: #2DB433;">
      Save ₹647
    </div>
  </div>

  <div class="flex justify-center px-1 border-2 border-[#6E6E6E4D] cursor-pointer flex-col items-start py-4 w-24 desktop:px-2" id="step5">
    <img src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_uncheck.svg?v=1714027668" alt="" class="h-4 mb-2 w-4 step5Img">
    <label class="font-semibold text-gray-800 text-[15px]" for="step5">5 Step</label>
    <div class="flex items-center space-x-1 text-[13px]">
      <span class="text-gray-500 opacity-30  line-through">₹2845</span>
      <span class="font-bold text-[#DE5844]" style="font-size: 14px;">₹1499</span>
    </div>
    <div class="mt-1 rounded-[4px] px-2 py-[2px] text-[12px] text-white" style="background-color: #2DB433;">
      Save ₹1346
    </div>
  </div>
</div>
 <div class='text-left px-2 desktop:px-0 hidden'> <h3 class='font-bold mb-3 text-gray-900 planTitle text-lg'>What You Get With Your 3 Step Regimen</h3> <ul class=space-y-2> <li class='flex items-center'><img src='https://cdn.shopify.com/s/files/1/0671/6686/3619/files/checkmark.svg?v=1701765920'class=mr-3> <span class='planContents'> Contains Oil, Shampoo & Serum </span> <li class='flex items-center'><img src='https://cdn.shopify.com/s/files/1/0671/6686/3619/files/checkmark.svg?v=1701765920'class=mr-3> Helps control hair fall <li class='flex items-center'><img src='https://cdn.shopify.com/s/files/1/0671/6686/3619/files/checkmark.svg?v=1701765920'class=mr-3> Reduces hair damage and makes hair healthy </ul> </div> 
 <div id="regimen">
 <h2 class="font-bold mb-2 capitalize nameTitleCurrentPlan">${customerName}'s <span>3-Step Customized Ayurvedic Regimen</span></h2> <ul> 
${prodCategories
  .map(
    (prodCategory) => `
    <li class="regimen_card cursor-pointer bg-[#FFFBF8] flex items-center justify-between border border-[#EBEBEB] px-2 mb-2 shadow-sm bg-[#FFFBF8] ${prodCategory}">
      <div class="analysis_desc flex items-center flex-1"></div>
    </li>
  `
  )
  .join("")}</ul>
<div class="mx-auto grid grid-cols-1 gap-2 items-start">
      
      
        <div class="freebie_card cursor-pointer flex items-center justify-between flex-1 border border-[#EBEBEB] bg-[#FFFBF8] px-3 shadow-sm freebie1-desc">
          <div class="flex items-center flex-1">
            <div class="flex items-center flex-1">
              <div>
                <img src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/freebie_oil.png?v=1722416305" alt="Booster Oil" class="w-[63px] object-cover">
              </div>
              <div class="flex flex-col gap-4 p-4">
              <h2 class="text-sh1 text-black">
                      Saha Bhringraj Booster Oil   
               </h2>
              <div class="py-2">
                <s>Rs.299/-</s> <span class="text-olivine-500 font-bold">FREE</span>
              </div>
            </div>
            </div>
            <div class="text-lg font-bold text-[#DE5844]"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"></path> </svg> </div>
          </div>
        </div>
      
        <div class="freebie_card cursor-pointer flex items-center justify-between flex-1 border border-[#EBEBEB] bg-[#FFFBF8] px-3 shadow-sm freebie2-desc">
          <div class="flex items-center flex-1">
            <div class="flex items-center flex-1">
              <div>
                <img src="https://cdn.shopify.com/s/files/1/0037/7690/5283/files/free_pdf.png?v=1713953012" alt="Vedix Prakriti E-Book" class="w-[63px] object-cover">
              </div>
              <div class="flex flex-col gap-4 p-4">
              <h2 class="text-sh1 text-black">
                Vedix Prakriti E-Book
              </h2>
              <div class="py-2">
                <s>Rs.499/-</s> <span class="text-olivine-500 font-bold">FREE</span>
              </div>
            </div>
            </div>
            <div class="text-lg font-bold text-[#DE5844]"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"></path> </svg> </div>
          </div>
        </div>
      
    </div>
</div>
 </div> 
 
 <div class='w-full bg-[#FBF7F1] bottom-0 fixed left-0 px-4 py-2'> <div class='flex items-center flex-col md:flex-row md:justify-between md:space-y-0 space-y-2'> <a class='flex items-center active justify-center bg-[#DE5844] border border-grey-200 cta_checkout h-[54px] max-w-md mx-auto w-full'data-plan=AP12 data-price-insider-new=1198 href=#select-plan id=cta_checkout> <span class='flex items-center active justify-center bg-terracotta-500 font-semibold h-[49px] md:w-full px-2 sm:w-full text-white'> CONTINUE <span> <span class='flex relative flex-row min-h-6 min-w-6'> <svg class='absolute size-6 transition-transform animate-bounceAlpha'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg> <path d='M0 0h24v24H0z'fill=none></path> <path d='M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path> </svg> <svg class='absolute size-6 transition-transform animate-bounceAlphaDelay left-2'fill=currentColor height=1em stroke=currentColor stroke-width=0 viewBox='0 0 24 24'width=1em xmlns=http://www.w3.org/2000/svg> <path d='M0 0h24v24H0z'fill=none></path> <path d='M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'></path> </svg> </span> </span> </span> </a> <div class='flex flex-col items-center h-[24px] max-w-[300px] overflow-hidden relative w-full'id=guaranteeCarousel> <div class='flex flex-col duration-500 ease-in-out transition-transform'id=guaranteeSlidesContainer></div> </div> </div> </div> </div> </div></div></div> <div class='sv_qstn hidden' id='analysis-loader'>
     <div class="intro relative bg-white border chat-bubble border-[#EBEBEB] p-6 mt-4 rounded-[6px] max-w-[60px]">
        <div class="snippet" data-title="dot-typing">
          <div class="stage">
            <div class="dot-typing"></div>
          </div>
        </div>
      </div> 
   </div>`;
  document.querySelector('form').classList.add('hidden');
  document.querySelector('form').insertAdjacentHTML('afterend', tqContent);
  document.querySelector('body').classList.remove('vpqScrollLock');
  setTimeout(() => {
    document.querySelector('#analysis-loader').classList.remove('hidden');
  },1000)
  setTimeout(() => {
    document.querySelector('.sv_qstn .intro').classList.add('pageCollapse');
    document.querySelector('body').classList.remove('vpqScrollLock');
    document.querySelector('#analysis-loader').classList.add('hidden');
  },4600);
  setTimeout(()=>{
    document.querySelector('.sv_qstn .intro').classList.add('hidden');
    document.querySelector('.sv_qstn .intro+div').classList.remove('hidden');
    document.querySelector('#surveyPrevButton').classList.add('hidden');
    document.querySelector('#nonSurveyPrevButton').classList.remove('hidden');
    console.log('customerName',customerName);
    const nameAnalysisElement = document.querySelector('#profile .custom-name-analysis');
    if (nameAnalysisElement) {
      nameAnalysisElement.innerText = `${customerName}'s`;
    }
    function fillerRemove(filler){
      if (filler.classList.contains('w-[25%]')) filler.classList.remove('w-[25%]');
      if (filler.classList.contains('w-[50%]')) filler.classList.remove('w-[50%]');
      if (filler.classList.contains('w-[75%]')) filler.classList.remove('w-[75%]');
      if (filler.classList.contains('w-full')) filler.classList.remove('w-full');
    }
    [...document.querySelectorAll("#MainContent .survey-section")].map((x,i) => {
      if(i == 0 && !!x.querySelector('.filler')) {
        let filler = x.querySelector('.filler');
        fillerRemove(filler);
        filler.classList.add('w-full');
      }
    });
    [...document.querySelectorAll('.survey-section')].map((x,i) => {
      if(i ==1){
        x.classList.add('w-6/9','active');
        x.classList.remove('w-1/9');
        x.querySelector('.filler').classList.add('w-full');
      }else {
        x.classList.add('w-1/9');
        x.classList.remove('w-6/9','active');
      }
    });
    let preAnalysisData = survey.data;

    const p = Object.values(survey.data).filter((r) => r.toString().startsWith('Pitta-')).length;
    const v = Object.values(survey.data).filter((r) => r.toString().startsWith('Vata-')).length;
    const k = Object.values(survey.data).filter((r) => r.toString().startsWith('Kapha-')).length;
    preAnalysisData.prakruti = getPrakruti(preAnalysisData);
    preAnalysisData = setHairAndScalpType(preAnalysisData);
    preAnalysisData = setPrakrutiId(preAnalysisData);
    preAnalysisData = setAlopeciaType(preAnalysisData);
    window.customer = {};
    window.customer.vpqJson = preAnalysisData;
    outsideFunction(preAnalysisData);
    issues[preAnalysisData.prakrutiId].forEach((icon) => {
      document.querySelector(`#analysisIntro .${icon}`).classList.remove('hidden');
    });
    document.querySelectorAll('.imbalDosha-1, .imbalDosha-2').forEach((el, i) => {
      el.textContent = preAnalysisData.prakruti.split('-')[i];
    });
    let currentSelectedDosha = 'vata';
    const doshaBoxTitle = document.querySelector('#analysisIntro .dynDoshaTitle');
    const doshaBoxImage = document.querySelector('#analysisIntro .dynDoshaImage');
    const doshaBoxDesc = document.querySelector('#analysisIntro .dynDoshaDesc');
    const doshaImbPercent = document.querySelector('#analysisIntro .composition-dosha-qty');
    function fillDoshaBoxes(per){
      [...document.querySelectorAll('#analysisIntro .dosha_progress')].map((x,i) => {
        x.classList.remove('!bg-[#DD5744]');
        if(i<=(Math.ceil(5 * Math.ceil((per * 100) / (p + v + k))/100) -1)){
          x.classList.add('!bg-[#DD5744]');
        } else {
          x.classList.remove('!bg-[#DD5744]');
        }
      })
    }
    fillDoshaBoxes(v);
    doshaImbPercent.innerText = Math.ceil((v * 100) / (p + v + k)) + '%';
    document.querySelector('#analysisIntro .vataSelector').addEventListener('click', (e) => {
      currentSelectedDosha = 'vata';
      doshaBoxTitle.innerText = 'Vata';
      doshaBoxImage.src = 'https://cdn.shopify.com/s/files/1/0607/5098/7446/files/dosha-icon-vata.svg';
      doshaBoxDesc.innerText = 'Imbalance of Vata Dosha can lead to dry scalp, frizzy hair, dandruff, split-ends, hair thinning and more.';
      doshaImbPercent.innerText = Math.ceil((v * 100) / (p + v + k)) + '%';
      fillDoshaBoxes(v);
    });
    document.querySelector('#analysisIntro .pittaSelector').addEventListener('click', (e) => {
      currentSelectedDosha = 'pitta';
      doshaBoxTitle.innerText = 'Pitta';
      doshaBoxImage.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/pitta-icon-guide.svg?v=1737723669';
      doshaBoxDesc.innerText = 'Imbalance of Pitta Dosha can lead to premature greying, scalp irritation, hair fall, hair thinning and more.';
      doshaImbPercent.innerText = Math.ceil((p * 100) / (p + v + k)) + '%';
      fillDoshaBoxes(p);
    });
    document.querySelector('#analysisIntro .kaphaSelector').addEventListener('click', (e) => {
      currentSelectedDosha = 'kapha';
      doshaBoxTitle.innerText = 'Kapha';
      doshaBoxImage.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/kapha-onboard-guid.svg?v=1737723357';
      doshaBoxDesc.innerText = 'Imbalance of Kapha Dosha can lead to slow hair growth, oily scalp, dull hair, scalp infections and more.';
      doshaImbPercent.innerText = Math.ceil((k * 100) / (p + v + k)) + '%';
      fillDoshaBoxes(k);
    });
    const prevFooter = document.querySelector('#footerLoader');
    prevFooter?.remove();
    const guaranteeItems = [
      {
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/money-back-onb-gu.svg?v=1737783253",
        text: "30 Day Money Back Guarantee",
      },
      {
        image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/free-del-footer.png?v=1738053173",
        text: "Free Shipping on All Orders",
      },
      {
        image: survey.data['question1c']==='Male'?"https://cdn.shopify.com/s/files/1/0037/7690/5283/files/grp-rev-male-guided.png?v=1746538593":"https://cdn.shopify.com/s/files/1/0037/7690/5283/files/grp-rev-guided.png?v=1738055640",
        text: "2,00,000+ Happy Customers",
      },
    ];

    const guaranteeSlidesContainer = document.getElementById("guaranteeSlidesContainer");
    let currentIndex = 0;

// Function to create a slide
    function createGuaranteeSlide(item) {
      const slide = document.createElement("div");
      slide.className = "guarantee-slide";
      slide.innerHTML = `
    <img alt="Icon" class="h-5" src="${item.image}" style="max-width: 3rem" />
    <span class="text-[#9E6D44] text-sm">${item.text}</span>
  `;
      return slide;
    }

// Function to initialize slides
    function initializeGuaranteeSlides() {
      guaranteeItems.forEach((item) => {
        const slide = createGuaranteeSlide(item);
        guaranteeSlidesContainer.appendChild(slide);
      });
    }

// Function to update the carousel
    function updateGuaranteeCarousel() {
      const slideHeight = 24; // Fixed height of each slide
      guaranteeSlidesContainer.style.transition = "transform 0.5s ease-in-out";
      guaranteeSlidesContainer.style.transform = `translateY(-${currentIndex * slideHeight}px)`; // Scroll vertically to the current index

      if (currentIndex === guaranteeItems.length) {
        setTimeout(() => {
          guaranteeSlidesContainer.style.transition = "none"; // Disable transition
          guaranteeSlidesContainer.style.transform = "translateY(0px)";
          currentIndex = 0;
        }, 400);
      }
    }

// Automatically cycle through guarantee items
    setInterval(() => {
      // currentIndex = (currentIndex + 1) % guaranteeItems.length; // Move to the next slide
      currentIndex++;
      updateGuaranteeCarousel();
    }, 3000);

// Initial setup
    initializeGuaranteeSlides();
    updateGuaranteeCarousel();

  },4800);

  function regimenAccordingToPlans(stepNumber) {
    [...document.querySelectorAll('#regimen ul>li.regimen_card')].map((y, j) =>{
      y.classList.remove('hidden');
      if(j>(+stepNumber-1)){
        y.classList.add('hidden');
      }
    });
  }
  regimenAccordingToPlans(3);

  document.querySelector('.introCta').addEventListener('click',function (){
    document.querySelector('#analysisIntro').classList.add('hidden');
    document.querySelector('#purchaseSection').classList.remove('hidden');
    history.pushState(
      { page: survey.currentPageNo+1 },
      "",
      `?${window.location.href.split('?')[1]}`
    );
    setTimeout(()=>{
      [...document.querySelectorAll('.survey-section')].map((x,i) => {
        if(i ==2){
          x.classList.add('w-6/9','active');
          x.classList.remove('w-1/9');
          x.querySelector('.filler').classList.add('w-full');
        }else {
          x.classList.add('w-1/9');
          x.classList.remove('w-6/9','active');
        }
      });

      [...document.querySelectorAll('.regimen_card')].map((x,i) => {
        x.addEventListener('click',function (){
          [...document.querySelectorAll('#subs-modal-inner>div')].map(y => y.classList.add('hidden'));
          document.getElementById('subs-modal').classList.remove('hidden');
          document.querySelector('body').classList.add('overflow-hidden');
          document.querySelector(`#subs-modal-inner>div:nth-child(${i+1})`).classList.remove('hidden');
        })
      });
      [...document.querySelectorAll('.freebie_card')].map((x,i) => {
        x.addEventListener('click',function (){
          let prakritiInfo = `
  <div class="flex border-b border-solid border-black">
    <div class="block p-4">
      <img src="//vedix.com/cdn/shop/files/free_pdf.png?v=1713953012" loading="lazy" alt="Prakriti E-Book" class="object-cover">
    </div>
    <div class="flex flex-col gap-4 p-4">
      <h3 class="text-sh1 text-black">Vedix Prakriti E-Book</h3>
      <div class="text-body1 text-black">Customised diet and dosha balancing e-guide</div>
      <div class=""></div>
    </div>
  </div>
  <div class="text-body1 flex-1 p-4 text-black">The guide is carefully designed by Ayurvedic experts and dieticians according to your dosha. It features home remedies to fight hair fall and other issues + tips to increase hair growth. It also lists diet & exercise recommendations for optimum lifestyle and well-being. </div>
              `;
          let brahmiBoosterInfo = `
              <div class="modalCard">
  <div class="flex border-b border-solid border-black">
    <div class="block p-4">
      <img src="//vedix.com/cdn/shop/files/freebie_oil.png?v=1722416305" loading="lazy" alt="Booster oil" class="w-[100px] tablet:w-[110px] object-cover">
    </div>
    <div class="flex flex-col gap-4 p-4">
         <h3 class="text-sh1 text-black">Saha Bhringraj Booster Oil</h3>
      <div class="text-body1 text-black">For stronger & longer hair</div>
      <div class=""></div>
      <ul class="flex w-full flex-row gap-x-8">
        <li class="flex items-center gap-x-[6px] text-[12px]/[20px] text-black">
          <svg xmlns="http://www.w3.org/2000/svg" width="8.104" height="12.677" viewBox="0 0 8.104 12.677">
            <path id="Path_7847" data-name="Path 7847" d="M317.405,220.521l3.362-6.661a.287.287,0,0,1,.514,0l3.366,6.661a4,4,0,0,1-.743,4.637l-.047.047a4,4,0,0,1-5.663,0l-.047-.047A4,4,0,0,1,317.405,220.521Zm3.621-5.889-3.1,6.149c0,.007-.007.013-.011.02a1.866,1.866,0,0,0,1.756,2.67,3.7,3.7,0,0,0,2.49-1.084l.047-.047c.049-.049.1-.1.144-.153a3.593,3.593,0,0,0,.47-4Z" transform="translate(-316.974 -213.7)" fill="#333"></path>
          </svg>
          10ml
        </li>
        <li class="flex items-center gap-x-[6px] text-[12px]/[20px] text-black">
          <svg xmlns="http://www.w3.org/2000/svg" width="13.43" height="12.302" viewBox="0 0 13.43 12.302">
            <g id="Group_5668" data-name="Group 5668" transform="translate(-1.852 -2.141)">
                <path id="Path_7848" data-name="Path 7848" d="M8.047,2.141a6.153,6.153,0,1,0,5.645,8.552.519.519,0,1,0-.956-.4,5.11,5.11,0,1,1,.257-3.228l-.463-.406a.516.516,0,1,0-.679.778l1.536,1.346a.517.517,0,0,0,.786-.126L15.21,6.9a.517.517,0,0,0-.889-.527l-.3.518A6.171,6.171,0,0,0,8.633,2.172q-.295-.03-.586-.031ZM7.58,5.1a.516.516,0,0,0-.519.515V9.446a.517.517,0,0,0,.324.481l2.223.9a.517.517,0,0,0,.384-.96L8.095,9.1V5.619A.516.516,0,0,0,7.58,5.1Z" fill="#333"></path>
            </g>
          </svg>
          30 days
        </li>
      </ul>
    </div>
  </div>
 <div class="text-body1 flex-1 p-4 text-black">
Enhance the strength of your hair oil with the help of this booster oil. It has Bhringraj and Sesame oil that ensure concentrated action on your scalp & roots for healthier, stronger, and thicker hair growth. The booster oil also reverses hair damage and has anti-aging herbs for hair.
<p class="text-sh1 relative text-black font-semibold mt-4">Power Ingredients</p>
  <div class="flex gap-2 mt-3">
      <div><img src="//vedix.com/cdn/shop/files/pk_brahmi.png?v=1614360035" loading="lazy" alt="Strengthen Your Hair Roots With Grapeseed" class="mx-auto h-10 w-10 object-cover rounded-full">
        <p class="text-gray-600 text-xs text-center font-normal">Bhringraj</p></div>
      <div><img src="//vedix.com/cdn/shop/files/analysis-pi-sesamum.png?v=1707283840" loading="lazy" alt="Boost Your Hair Growth With Kumari (Aloe Vera)" class="mx-auto h-10 w-10 object-cover rounded-full">
        <p class="text-gray-600 text-xs font-normal">Sesame</p></div>
  </div>
</div>
</div>
              `;
          [...document.querySelectorAll('#freebie-modal #subs-modal-inner>div')].map(y => y.classList.add('hidden'));
          document.getElementById('freebie-modal').classList.remove('hidden');
          document.querySelector('body').classList.add('overflow-hidden');
          document.querySelector(`#freebie-modal #subs-modal-inner`).innerHTML = i==0 ? brahmiBoosterInfo : prakritiInfo;
        })
      });
      document.querySelector('#subs-modal button').addEventListener('click',function (){
        document.querySelector('#subs-modal').classList.add('hidden');
        document.querySelector('body').classList.remove('overflow-hidden');
      });
      document.querySelector('#freebie-modal button').addEventListener('click',function (){
        document.querySelector('#freebie-modal').classList.add('hidden');
        document.querySelector('body').classList.remove('overflow-hidden');
      });

      const plan3Selector = document.querySelector('#purchaseSection #step3');
      const plan4Selector = document.querySelector('#purchaseSection #step4');
      const plan5Selector = document.querySelector('#purchaseSection #step5');
      const plan3SelectorImg = document.querySelector('#purchaseSection .step3Img');
      const plan4SelectorImg = document.querySelector('#purchaseSection .step4Img');
      const plan5SelectorImg = document.querySelector('#purchaseSection .step5Img');
      const currPlanTitle = document.querySelector('#purchaseSection .planTitle');
      const currPlanContents = document.querySelector('#purchaseSection .planContents');
      const nameTitleCurrPlan = document.querySelector('#purchaseSection .nameTitleCurrentPlan span');

      const imagesFor3Step = [
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/3-Step-Regimen.jpg?v=1735296934",
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/sp3-1.png?v=1735210765",
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/sp3-2.png?v=1735210765",
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/sp3-3.png?v=1735210765",
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/sp3-4.png?v=1735210765",
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/sp3-5.png?v=1735210765",
      ];
      const imagesFor4Step = ['https://cdn.shopify.com/s/files/1/0037/7690/5283/files/4-Step-Regimen.jpg?v=1735297006',
        'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/4s4.png?v=1735297268','https://cdn.shopify.com/s/files/1/0037/7690/5283/files/4s1.png?v=1735297268',
        'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/4s2.png?v=1735297267','https://cdn.shopify.com/s/files/1/0037/7690/5283/files/4s3.png?v=1735297267',
        'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/4s5.png?v=1735297267', 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/4s6.png?v=1735297267'];
      const imagesFor5Step = [
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/5-Step-Regimen.jpg?v=1735297030",
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/5s3.png?v=1735297537", 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/5s4.png?v=1735297537',
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/5s2.png?v=1735297537", 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/5s1.png?v=1735297537',
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/5s5.png?v=1735297537", 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/4s6.png?v=1735297267',
        "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/4s5.png?v=1735297267",
      ];
      let images = imagesFor3Step;
      function createCheckout(stepNumber){
        [...document.querySelectorAll('.cta_checkout')].map(z => {
          z.dataset.plan = stepNumber ==3 ? 'AP12' : stepNumber ==4 ? 'APC12' : 'APRP12';
          z.dataset.priceInsiderNew = stepNumber ==3 ? '1198' : stepNumber ==4 ? '1519' : '1599';
        });
      }
      plan3Selector.addEventListener('click', (e) => {
        plan3SelectorImg.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_check.svg?v=1714027670';
        plan4SelectorImg.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_uncheck.svg?v=1714027668';
        plan5SelectorImg.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_uncheck.svg?v=1714027668';
        plan3Selector.classList.add('!border-[#DE5844]');
        plan4Selector.classList.remove('!border-[#DE5844]');
        plan5Selector.classList.remove('!border-[#DE5844]');
        images = imagesFor3Step;
        currentIndex = 0;
        updateCarousel();
        createIndicators();
        createCheckout(3);
        regimenAccordingToPlans(3);
        currPlanTitle.innerText = 'What You Get With Your 3 Step Regimen';
        currPlanContents.innerText = 'Contains Oil, Shampoo & Serum';
        nameTitleCurrPlan.innerText = '3-Step Customized Ayurvedic Regimen';
      });
      plan4Selector.addEventListener('click', (e) => {
        plan3SelectorImg.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_uncheck.svg?v=1714027668';
        plan4SelectorImg.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_check.svg?v=1714027670';
        plan5SelectorImg.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_uncheck.svg?v=1714027668';
        plan3Selector.classList.remove('!border-[#DE5844]');
        plan4Selector.classList.add('!border-[#DE5844]');
        plan5Selector.classList.remove('!border-[#DE5844]');
        images = imagesFor4Step;
        currentIndex = 0;
        updateCarousel();
        createIndicators();
        createCheckout(4);
        regimenAccordingToPlans(4);
        currPlanTitle.innerText = 'What You Get With Your 4 Step Regimen';
        currPlanContents.innerText = 'Contains Oil, Shampoo, Serum & Conditioner';
        nameTitleCurrPlan.innerText = '4-Step Customized Ayurvedic Regimen';
      });
      plan5Selector.addEventListener('click', (e) => {
        plan3SelectorImg.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_uncheck.svg?v=1714027668';
        plan4SelectorImg.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_uncheck.svg?v=1714027668';
        plan5SelectorImg.src = 'https://cdn.shopify.com/s/files/1/0037/7690/5283/files/radio_check.svg?v=1714027670';
        plan3Selector.classList.remove('!border-[#DE5844]');
        plan4Selector.classList.remove('!border-[#DE5844]');
        plan5Selector.classList.add('!border-[#DE5844]');
        images = imagesFor5Step;
        currentIndex = 0;
        updateCarousel();
        createIndicators();
        createCheckout(5);
        regimenAccordingToPlans(5);
        currPlanTitle.innerText = 'What You Get With Your 5 Step Regimen';
        currPlanContents.innerText = 'Contains Oil, Shampoo, Serum, Conditioner & Hair Pack';
        nameTitleCurrPlan.innerText = '5-Step Customized Ayurvedic Regimen'
      });


      //   Carousel Logic

      const prevImg = document.querySelector(".prev-img img");
      const mainImg = document.querySelector(".main-img img");
      const nextImg = document.querySelector(".next-img img");
      const indicatorsContainer = document.getElementById("indicators");
      const prevButton = document.getElementById("prev");
      const nextButton = document.getElementById("next");

      let currentIndex = 0;


      // Function to update the carousel
      const updateCarousel = () => {
        const prevIndex = (currentIndex - 1 + images.length) % images.length;
        const nextIndex = (currentIndex + 1) % images.length;

        prevImg.src = images[prevIndex];
        mainImg.src = images[currentIndex];
        nextImg.src = images[nextIndex];

        updateIndicators(); // Ensure indicators are updated here
      };

      // Function to create indicators
      const createIndicators = () => {
        indicatorsContainer.innerHTML = ""; // Clear any existing indicators
        document.querySelectorAll('.indicator-dots')?.forEach(dot => dot.remove());
        images.forEach((_, index) => {
          const indicator = document.createElement("button");
          // Add base classes for the indicator button
          indicator.classList.add(
              "w-2",
              "h-2",
              "rounded-full",
              "bg-[#D9D9D9]", // Default inactive color
              "transition-colors", // Smooth color transition
              "hover:bg-gray-400",
              "indicator-dots"
          );

          // Highlight the current active indicator
          if (index === currentIndex) {
            indicator.classList.replace("bg-[#D9D9D9]", "bg-[#DE5844]"); // Active color
          }

          // Set the indicator to reference its index
          indicator.setAttribute("data-index", index);

          // Add click functionality to navigate to the respective image
          indicator.addEventListener("click", () => {
            currentIndex = index; // Update the active index
            updateCarousel(); // Update the carousel to the selected image
          });

          // Append the indicator to the container
          indicatorsContainer.appendChild(indicator);
        });
      };

      // Function to update the indicators
      const updateIndicators = () => {
        Array.from(indicatorsContainer.children).forEach((indicator, index) => {
          // Remove both active and inactive classes
          indicator.classList.remove("bg-[#DE5844]", "bg-[#D9D9D9]");

          if (index === currentIndex) {
            indicator.classList.add("bg-[#DE5844]"); // Active color
          } else {
            indicator.classList.add("bg-[#D9D9D9]"); // Default inactive color
          }
        });
      };

      // Event listeners for navigation buttons
      prevButton.addEventListener("click", () => {
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        updateCarousel();
      });

      nextButton.addEventListener("click", () => {
        currentIndex = (currentIndex + 1) % images.length;
        updateCarousel();
      });

      // Initialize carousel
      // createIndicators();
      // updateCarousel();

      const ctaBtns = document.querySelectorAll('.cta_checkout');
      ctaBtns.forEach(function (ctaBtn) {
        ctaBtn.addEventListener('click', async function (e) {
          e.preventDefault();
          window.plans =e.currentTarget.dataset.plan;
          window.price =  e.currentTarget.dataset.priceInsiderNew;
          const params = checkoutRequest(e.currentTarget.dataset.plan, e.currentTarget.dataset.priceInsiderNew);
          const req = await fetch(`${gkApiUrl}/checkout/`, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: {
              'Content-Type': 'application/json',
            },
          });
          const resp = await req.json();
          if (!resp.checkout || !resp.checkout.checkout_id) {
            console.log(resp);
          } else {
            const checkout = resp.checkout;
            checkout.merchantCheckoutId = checkout.checkout_id;
            window.goKwikCheckoutId = checkout.checkout_id;
            gokwikSdk.initCheckout({
              environment: 'sandbox',
              type: 'merchantInfo',
              mid: gkMid,
              merchantParams: checkout,
              bannerMessages: getCookie('no_booster_freebie') ? ['<b>Free</b> Dosha E-book On All Orders'] : getCookie('price_increase_expt') ? ['<b>Extra</b> Rs.100 Off On UPI/Card Payments'] : ['<b>Free</b> Dosha E-book On Pre-paid Orders'],
            });
          }
        });
      });

      const pguaranteeItems = [
        {
          image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/money-back-onb-gu.svg?v=1737783253",
          text: "30 Day Money Back Guarantee",
        },
        {
          image: "https://cdn.shopify.com/s/files/1/0037/7690/5283/files/free-del-footer.png?v=1738053173",
          text: "Free Shipping on All Orders",
        },
        {
          image: survey.data['question1c']==='Male'?"https://cdn.shopify.com/s/files/1/0037/7690/5283/files/grp-rev-male-guided.png?v=1746538593":"https://cdn.shopify.com/s/files/1/0037/7690/5283/files/grp-rev-guided.png?v=1738055640",
          text: "2,00,000+ Happy Customers",
        },
      ];

      const pricingguaranteeSlidesContainer = document.querySelector("#purchaseSection #guaranteeSlidesContainer");
      let currentIndexFooterPrice = 0;

// Function to create a slide
      function createGuaranteeSlidePrice(item) {
        const slide = document.createElement("div");
        slide.className = "guarantee-slide";
        slide.innerHTML = `
    <img alt="Icon" class="h-5" src="${item.image}" style="max-width: 3rem" />
    <span class="text-[#9E6D44] text-sm">${item.text}</span>
  `;
        return slide;
      }

// Function to initialize slides
      function initializeGuaranteeSlidesPrice() {
        pguaranteeItems.forEach((item) => {
          const slide = createGuaranteeSlidePrice(item);
          pricingguaranteeSlidesContainer.appendChild(slide);
        });
      }

// Function to update the carousel
      function updateGuaranteeCarouselPrice() {
        const slideHeight = 24; // Fixed height of each slide
        pricingguaranteeSlidesContainer.style.transition = "transform 0.5s ease-in-out";
        pricingguaranteeSlidesContainer.style.transform = `translateY(-${currentIndexFooterPrice * slideHeight}px)`; // Scroll vertically to the current index

        if (currentIndexFooterPrice === pguaranteeItems.length) {
          setTimeout(() => {
            pricingguaranteeSlidesContainer.style.transition = "none"; // Disable transition
            pricingguaranteeSlidesContainer.style.transform = "translateY(0px)";
            currentIndexFooterPrice = 0;
          }, 400);
        }
      }

// Automatically cycle through guarantee items
      setInterval(() => {
        currentIndexFooterPrice++; // Move to the next slide
        updateGuaranteeCarouselPrice();
      }, 3000);

// Initial setup
      initializeGuaranteeSlidesPrice();
      updateGuaranteeCarouselPrice();
    },1000);
  });
  // window.addEventListener('popstate', () => {
  //   document.body.focus();
  //   document.body.click();
  //   console.log('123');
  //   [...document.querySelectorAll('form+div.sv_qstn >div')].map((x,i) => {
  //     if(x.clientHeight !=0 && x.id=='analysisPreview') {
  //       x.classList.add('hidden');
  //       x.parentElement.classList.add('hidden');
  //       document.querySelector('#surveyPrevButton').classList.remove('hidden');
  //       document.querySelector('#nonSurveyPrevButton').classList.add('hidden');
  //       document.querySelector('form').classList.remove('hidden');
  //       location.reload();
  //     }
  //     else
  //
  //     if(x.clientHeight !=0 && x.id == 'purchaseSection') {
  //       console.log('inside');
  //       if(x.id == 'purchaseSection'){
  //         [...document.querySelectorAll('.survey-section')].map((x,i) => {
  //           console.log('Fillers',x);
  //           if (i == 2) {
  //             document.querySelectorAll('.survey-section')[2].querySelector('.filler').classList.remove('w-full');
  //             document.querySelectorAll('.survey-section')[2].classList.remove('w-6/9', 'active');
  //             document.querySelectorAll('.survey-section')[2].classList.add('w-1/9');
  //             document.querySelectorAll('.survey-section')[1].classList.add('w-6/9','active');
  //             // document.querySelectorAll('.survey-section span')[2].classList.remove('hidden');
  //           }
  //         });
  //         document.querySelector('#analysisIntro').classList.remove('hidden');
  //         document.querySelector('#purchaseSection').classList.add('hidden');
  //       }
  //       x.classList.add('hidden');
  //       if(!!x.previousElementSibling)  x.previousElementSibling.classList.remove('hidden');
  //     }
  //
  //     if(x.clientHeight !=0 && x.id == 'analysisPreview') {
  //       console.log('inside analysis');
  //       [...document.querySelectorAll('.survey-section')].map((x,i) => {
  //         if (i == 1) {
  //           document.querySelectorAll('.survey-section')[1].querySelector('.filler').classList.remove('w-full');
  //           document.querySelectorAll('.survey-section')[1].classList.remove('w-6/9', 'active');
  //           document.querySelectorAll('.survey-section')[1].classList.add('w-1/9');
  //           document.querySelectorAll('.survey-section')[0].classList.add('w-6/9','active');
  //         }
  //       });
  //       x.classList.add('hidden');
  //       x.parentElement.classList.add('hidden');
  //       document.querySelector('#surveyPrevButton').classList.remove('hidden');
  //       document.querySelector('#nonSurveyPrevButton').classList.add('hidden');
  //       document.querySelector('form').classList.remove('hidden');
  //       location.reload();
  //     }
  //     else x.classList.add('hidden');
  //   })
  // });
  document.querySelector('#nonSurveyPrevButton').addEventListener('click',function (){
    [...document.querySelectorAll('form+div.sv_qstn >div')].map((x,i) => {
      if(x.clientHeight !=0 && x.id=='analysisPreview') {
        x.classList.add('hidden');
        x.parentElement.classList.add('hidden');
        document.querySelector('#surveyPrevButton').classList.remove('hidden');
        document.querySelector('#nonSurveyPrevButton').classList.add('hidden');
        document.querySelector('form').classList.remove('hidden');
        location.reload();
      }
      else

        if(x.clientHeight !=0 && x.id == 'purchaseSection') {
          console.log('inside');
          if(x.id == 'purchaseSection'){
          [...document.querySelectorAll('.survey-section')].map((x,i) => {
            console.log('Fillers',x);
            if (i == 2) {
              document.querySelectorAll('.survey-section')[2].querySelector('.filler').classList.remove('w-full');
              document.querySelectorAll('.survey-section')[2].classList.remove('w-6/9', 'active');
              document.querySelectorAll('.survey-section')[2].classList.add('w-1/9');
              document.querySelectorAll('.survey-section')[1].classList.add('w-6/9','active');
              // document.querySelectorAll('.survey-section span')[2].classList.remove('hidden');
            }
          });
          document.querySelector('#analysisIntro').classList.remove('hidden');
          document.querySelector('#purchaseSection').classList.add('hidden');
        }
        x.classList.add('hidden');
        if(!!x.previousElementSibling)  x.previousElementSibling.classList.remove('hidden');
      }

        if(x.clientHeight !=0 && x.id == 'analysisPreview') {
          console.log('inside analysis');
          [...document.querySelectorAll('.survey-section')].map((x,i) => {
            if (i == 1) {
              document.querySelectorAll('.survey-section')[1].querySelector('.filler').classList.remove('w-full');
              document.querySelectorAll('.survey-section')[1].classList.remove('w-6/9', 'active');
              document.querySelectorAll('.survey-section')[1].classList.add('w-1/9');
              document.querySelectorAll('.survey-section')[0].classList.add('w-6/9','active');
            }
          });
            x.classList.add('hidden');
            x.parentElement.classList.add('hidden');
            document.querySelector('#surveyPrevButton').classList.remove('hidden');
            document.querySelector('#nonSurveyPrevButton').classList.add('hidden');
            document.querySelector('form').classList.remove('hidden');
            location.reload();
        }
      else x.classList.add('hidden');
    })

  });
}

function showThankYouPage(vpq_result) {
  if (vpq_result.question1c === "Male") {
    document.querySelector(".vpq-end .women").classList.add("hidden");
    document.querySelector(".vpq-end .men").classList.remove("hidden");
  }
  document.querySelector(".vpq-wizard").classList.add("hidden");
  document
    .querySelectorAll(".header-nav")
    .forEach((el) => el.classList.add("hidden"));
  document.querySelector(".vpq-end").classList.remove("hidden");
}

document.addEventListener("DOMContentLoaded", function () {
// noinspection JSUnresolvedVariable,JSUnresolvedFunction
  Survey.FunctionFactory.Instance.register("tieBreaker", tieBreaker);
// Survey.settings.autoAdvanceDelay = 3000;
// noinspection JSUnresolvedVariable
  window.survey = new Survey.Model(vpqJson);
  survey.locale = document.documentElement.getAttribute("lang");
  if(getCookie('mysurvey')) {
    // Restore survey results
    const prevData = getCookie('mysurvey');
    if (prevData) {
      const data = JSON.parse(prevData);
      console.log('mysurvey cookies get')
      window.survey.data = data;
      if (data.pageNo) {
        survey.currentPageNo = data.pageNo;
        setTimeout(()=>{
        console.log(data.pageNo,!!document.querySelector('.responseCont'))
        if (data.pageNo != 0 && !!document.querySelector('.responseCont')) {
          document.getElementById('surveyPrevButton').classList.remove('hidden');
          let filler = document.querySelector('.filler');
          if (data.pageNo >= 2 && data.pageNo <6) filler.classList.add('w-[25%]');
          else if (data.pageNo >= 6 && data.pageNo <15) filler.classList.add('w-[50%]');
          else if (data.pageNo >= 15 && data.pageNo <24) filler.classList.add('w-[75%]');
          else if (data.pageNo >= 24) filler.classList.add('w-full');
        }
        },1000);
      }
    }
  }
//event handlers
  survey.onAfterRenderQuestion.add(initImagePicker);
  survey.onValueChanged.add(updateHistory);
  survey.onCurrentPageChanged.add(updateNavigation);
  survey.onAfterRenderQuestion.add(renderChatResponsesForPage);
  survey.onAfterRenderQuestion.add(renderFootersForPage);
  survey.onAfterRenderSurvey.add(surveyRendered);
  survey.onComplete.add(vpqComplete);


  survey.css = cssClasses;
// survey.render("surveyElement");
  ko.applyBindings({
    model: survey,
  });

  const enterQuiz = (e) => {
    e.preventDefault();
    if (inputEl.checkValidity()) {
      document.querySelector(".vpq-start").classList.add("hidden");
      document.querySelector(".vpq-wizard").classList.remove("hidden");
      document
        .querySelectorAll(".header-nav")
        .forEach((el) => el.classList.remove("hidden"));
      history.pushState(
        { page: survey.currentPageNo },
        "",
        `?page=${survey.currentPage.name}`
      );
      document.title = survey.currentPage.questions[0].title;
    }
  };
  const hideQuiz = () => {
    document.querySelector(".vpq-start").classList.remove("hidden");
    document.querySelector(".vpq-wizard").classList.add("hidden");
    document
      .querySelectorAll(".header-nav")
      .forEach((el) => el.classList.add("hidden"));
  };

//header nav
  const headerBack = document.querySelector(".header-back");
  headerBack.addEventListener("click", function () {
    if (survey.currentPageNo > 0) {
      survey.currentPageNo--;
      setTimeout(()=>{
        function fillerRemove(filler){
          if (filler.classList.contains('w-[25%]')) filler.classList.remove('w-[25%]');
          if (filler.classList.contains('w-[50%]')) filler.classList.remove('w-[50%]');
          if (filler.classList.contains('w-[75%]')) filler.classList.remove('w-[75%]');
          if (filler.classList.contains('w-full')) filler.classList.remove('w-full');
        }
        [...document.querySelectorAll("#MainContent .survey-section")].map((x,i) => {
          if(i == 0 && !!x.querySelector('.filler')) {
          let filler = x.querySelector('.filler');
          let pageNo = parseInt(survey.currentPageNo);
            if (pageNo < 2) {
              fillerRemove(filler)
              filler.classList.add('w-0');
            }
          else if (pageNo == 2) {
            fillerRemove(filler)
            filler.classList.add('w-[25%]');
          }
          else if (pageNo == 6) {
            fillerRemove(filler)
            filler.classList.add('w-[50%]');
          }
          else if (pageNo == 15) {
            fillerRemove(filler)
            filler.classList.add('w-[75%]');
          }
          else if (pageNo == 22) {
            fillerRemove(filler);
            filler.classList.add('w-full');
          }
        }
      });
      },500);
    } else {
      hideQuiz();
    }
    setTimeout(() => {
      document.body.click();
      console.log('body clicked!')
    },500)
  });
  // move to next question on clicking of answer already selected
  let isHandlingClick = false;

  document.querySelector("survey").addEventListener("click", function (e) {
    // Only proceed if we are not already handling a click.
    if (isHandlingClick || isProgrammaticUpdate) return;

    // Only run if the clicked element is inside a target container.
    if (
      e.target.closest(".sv_q_imgsel.checked") ||
      e.target.closest(".sv_q_radiogroup.checked")
    ) {
      isHandlingClick = true; // set the flag

      e.stopPropagation();

      const lastQustIdx = survey.currentPage.questions.length - 1;
      const lastQuestionElemId = survey.currentPage.questions[lastQustIdx].id;
      const lastQuestionName = survey.currentPage.questions[lastQustIdx].name;
      console.log("Already selected", survey.data[lastQuestionName]);

      setTimeout(() => {
        const contentElem = document.querySelector(
          `#${lastQuestionElemId} .sd-question__content`
        );
        if (contentElem) contentElem.classList.add("animate-collapse");

        // Determine the image URL based on gender
        const imageUrl = isMaleUser
          ? "https://cdn.shopify.com/s/files/1/0630/8528/1507/files/male-resp.jpg?v=1733740951"
          : "https://cdn.shopify.com/s/files/1/0630/8528/1507/files/female-resp.jpg?v=1733740951";

        console.log(
          document.querySelector(`#${lastQuestionElemId}-response`)
        );
        document
          .querySelector(`#${lastQuestionElemId}-response`)
          ?.remove();

        const userResponse =
          Object.values(survey.currentPage.getValue())[0] || "No response";
        console.log("User responses", userResponse);

        const userResponseText =
          survey.currentPage.questions[lastQustIdx].choices?.find(
            (choice) => choice.value === userResponse
          )?.text || "No response provided";
        console.log("User value", userResponseText);

        // Insert the response bubble into the DOM
        document
          .querySelector(`#${lastQuestionElemId}`)
          ?.insertAdjacentHTML(
            "afterend",
            `
        <div id="${lastQuestionElemId}-response" class="responseCont" style="display: flex; align-items: center; justify-content: flex-end; margin-top: 1rem;">
          <div class="speech-bubble px-6 py-3 bg-white relative response-bubble capitalize rounded-[10px] border border-[#EBEBEB]">
            ${userResponseText}
          </div>
          <img src="${imageUrl}" alt="User Icon" style="
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-left: 10px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          " />
        </div>
      `
          );
      }, 500);

      document
        .querySelector(`#${lastQuestionElemId} fieldset`)
        ?.classList.add("animate-collapse");
      document
        .querySelector(`#${lastQuestionElemId} .sv_q_title`)
        ?.classList.add("animate-title");

      setTimeout(() => {
        document.querySelector(".sd-body__page")?.classList.add("pageCollapse");
      }, 1000);

      setTimeout(() => {
        console.log("NEXT 3");
        survey.nextPage();
        // Reset the flag after the final action
        isHandlingClick = false;
      }, 1200);
    }
  }, true);


});

// handle browser back and fwd buttons
// window.onpopstate = (event) => {
//   if (event.state && typeof event.state.page !== "undefined") {
//     survey.currentPageNo = event.state.page;
//   }
// };

function isVisible(element) {
  return !!element && element.offsetParent !== null;
}

window.addEventListener('popstate', function(event) {
  // alert('popstate works');
  document.body.focus();
  document.body.click();
  console.log('456');
  // Get the #surveyPrevButton element
  const surveyPrevButton = document.querySelector('#surveyPrevButton');

  // Check if #surveyPrevButton is visible
  if (surveyPrevButton && isVisible(surveyPrevButton)) {
    document.body.click();
    console.log('back btn pressed');
    surveyPrevButton.click();
    // alert('Normal back')
    console.log('#surveyPrevButton was triggered since it is visible.');
  } else {
    console.log('#surveyPrevButton is not visible.');

    // Check if the button inside .glassy-header is visible and click it
    const headerNavButton = document.querySelector('.glassy-header button.header-nav');
    if (headerNavButton && isVisible(headerNavButton)) {
      document.body.click();
      console.log('header body');
      // alert('intersial back')
      headerNavButton.click();
      console.log('.header-nav button inside .glassy-header was triggered since it is visible.');
    } else {
      // alert('Error back')
      console.log('.header-nav button is not visible or not found in the DOM.');
      // survey.currentPageNo = event.state.page;
      // location.reload();
        document.body.focus();
        document.body.click();
        console.log('123');
        [...document.querySelectorAll('form+div.sv_qstn >div')].map((x,i) => {
          if(x.clientHeight !=0 && x.id=='analysisPreview') {
            x.classList.add('hidden');
            x.parentElement.classList.add('hidden');
            document.querySelector('#surveyPrevButton').classList.remove('hidden');
            document.querySelector('#nonSurveyPrevButton').classList.add('hidden');
            document.querySelector('form').classList.remove('hidden');
            location.reload();
          }
          else

          if(x.clientHeight !=0 && x.id == 'purchaseSection') {
            console.log('inside');
            if(x.id == 'purchaseSection'){
              [...document.querySelectorAll('.survey-section')].map((x,i) => {
                console.log('Fillers',x);
                if (i == 2) {
                  document.querySelectorAll('.survey-section')[2].querySelector('.filler').classList.remove('w-full');
                  document.querySelectorAll('.survey-section')[2].classList.remove('w-6/9', 'active');
                  document.querySelectorAll('.survey-section')[2].classList.add('w-1/9');
                  document.querySelectorAll('.survey-section')[1].classList.add('w-6/9','active');
                  // document.querySelectorAll('.survey-section span')[2].classList.remove('hidden');
                }
              });
              document.querySelector('#analysisIntro').classList.remove('hidden');
              document.querySelector('#purchaseSection').classList.add('hidden');
            }
            x.classList.add('hidden');
            if(!!x.previousElementSibling)  x.previousElementSibling.classList.remove('hidden');
          }

          if(x.clientHeight !=0 && x.id == 'analysisPreview') {
            console.log('inside analysis');
            [...document.querySelectorAll('.survey-section')].map((x,i) => {
              if (i == 1) {
                document.querySelectorAll('.survey-section')[1].querySelector('.filler').classList.remove('w-full');
                document.querySelectorAll('.survey-section')[1].classList.remove('w-6/9', 'active');
                document.querySelectorAll('.survey-section')[1].classList.add('w-1/9');
                document.querySelectorAll('.survey-section')[0].classList.add('w-6/9','active');
              }
            });
            x.classList.add('hidden');
            x.parentElement.classList.add('hidden');
            document.querySelector('#surveyPrevButton').classList.remove('hidden');
            document.querySelector('#nonSurveyPrevButton').classList.add('hidden');
            document.querySelector('form').classList.remove('hidden');
            location.reload();
          }
          else x.classList.add('hidden');
        })
    }
  }
});



function saveSurveyData (survey) {
  const data = survey.data;
  data.pageNo = survey.currentPageNo;
  setCookie('mysurvey', JSON.stringify(data));
}